// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// Single-sourced enum value sets + metadata. Source of truth is each
// shared/config/<name>.config.json. Frontend imports these instead of
// hand-maintaining duplicate value arrays / color / icon maps. Display
// labels stay in i18n locale files.

// ── WorkItemType — source: shared/config/sf_item_types.config.json ─
export const WORK_ITEM_TYPE_VALUES = ["idea", "feature", "bug", "tech_debt", "enhancement", "test", "data", "site_reliability"] as const;
export type WorkItemType = (typeof WORK_ITEM_TYPE_VALUES)[number];

export const workItemTypeBadgeClass: Record<WorkItemType, string> = {
  "idea": "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
  "feature": "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  "bug": "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
  "tech_debt": "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400",
  "enhancement": "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
  "test": "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-400",
  "data": "bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-400",
  "site_reliability": "bg-lime-100 text-lime-800 dark:bg-lime-900/30 dark:text-lime-400",
};

export const workItemTypeColor: Record<WorkItemType, string> = {
  "idea": "#8B5CF6",
  "feature": "#3B82F6",
  "bug": "#EF4444",
  "tech_debt": "#F59E0B",
  "enhancement": "#10B981",
  "test": "#06B6D4",
  "data": "#EC4899",
  "site_reliability": "#84CC16",
};

export const workItemTypeIcon: Record<WorkItemType, string> = {
  "idea": "Lightbulb",
  "feature": "Sparkles",
  "bug": "Bug",
  "tech_debt": "Wrench",
  "enhancement": "ArrowUp",
  "test": "FlaskConical",
  "data": "Database",
  "site_reliability": "Activity",
};

// ── WorkItemPriority — source: shared/config/sf_priorities.config.json ─
export const WORK_ITEM_PRIORITY_VALUES = [0, 1, 2, 3] as const;
export type WorkItemPriority = (typeof WORK_ITEM_PRIORITY_VALUES)[number];

export const workItemPriorityBadgeClass: Record<number, string> = {
  0: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
  1: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400",
  2: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  3: "bg-muted text-muted-foreground",
};

export const workItemPriorityColor: Record<number, string> = {
  0: "#EF4444",
  1: "#F59E0B",
  2: "#3B82F6",
  3: "#6B7280",
};

// ── ModuleCategory — source: shared/config/sf_categories.config.json ─
export const MODULE_CATEGORY_VALUES = ["product", "platform", "integration", "infrastructure"] as const;
export type ModuleCategory = (typeof MODULE_CATEGORY_VALUES)[number];

export const moduleCategoryColor: Record<ModuleCategory, string> = {
  "product": "#3B82F6",
  "platform": "#8B5CF6",
  "integration": "#10B981",
  "infrastructure": "#F59E0B",
};

// ── ModuleMaturity — source: shared/config/sf_module_maturities.config.json ─
export const MODULE_MATURITY_VALUES = ["planned", "alpha", "beta", "stable", "deprecated"] as const;
export type ModuleMaturity = (typeof MODULE_MATURITY_VALUES)[number];

export const moduleMaturityColor: Record<ModuleMaturity, string> = {
  "planned": "#6B7280",
  "alpha": "#F59E0B",
  "beta": "#2563EB",
  "stable": "#10B981",
  "deprecated": "#EF4444",
};

// ── ModuleStatus — source: shared/config/sf_module_statuses.config.json ─
export const MODULE_STATUS_VALUES = ["active", "archived"] as const;
export type ModuleStatus = (typeof MODULE_STATUS_VALUES)[number];

export const moduleStatusColor: Record<ModuleStatus, string> = {
  "active": "#10B981",
  "archived": "#6B7280",
};

export const moduleStatusTone: Record<ModuleStatus, string> = {
  "active": "info",
  "archived": "neutral",
};

// ── TaskBoardStatus — source: shared/config/task_board_statuses.config.json ─
export const TASK_BOARD_STATUS_VALUES = ["active", "archived"] as const;
export type TaskBoardStatus = (typeof TASK_BOARD_STATUS_VALUES)[number];

export const taskBoardStatusColor: Record<TaskBoardStatus, string> = {
  "active": "#10B981",
  "archived": "#6B7280",
};

// ── ProductRole — source: shared/config/product_catalog.config.json § product_role ─
export const PRODUCT_ROLE_VALUES = ["sell", "buy", "both"] as const;
export type ProductRole = (typeof PRODUCT_ROLE_VALUES)[number];

export const productRoleColor: Record<ProductRole, string> = {
  "sell": "green",
  "buy": "blue",
  "both": "gray",
};

export const productRoleIcon: Record<ProductRole, string> = {
  "sell": "Tag",
  "buy": "ShoppingCart",
  "both": "ArrowLeftRight",
};

// ── TargetRelationship — source: shared/config/target_relationship.config.json ─
export const TARGET_RELATIONSHIP_VALUES = ["lead", "partner", "vendor"] as const;
export type TargetRelationship = (typeof TARGET_RELATIONSHIP_VALUES)[number];

// ── ProspectStatus — source: shared/config/prospect_statuses.config.json ─
export const PROSPECT_STATUS_VALUES = ["new", "researched", "sequenced", "engaged", "replied", "meeting_booked", "converted", "not_interested", "do_not_contact"] as const;
export type ProspectStatus = (typeof PROSPECT_STATUS_VALUES)[number];

export const prospectStatusTone: Record<ProspectStatus, string> = {
  "new": "neutral",
  "researched": "info",
  "sequenced": "info",
  "engaged": "warning",
  "replied": "success",
  "meeting_booked": "success",
  "converted": "success",
  "not_interested": "neutral",
  "do_not_contact": "error",
};

export const prospectStatusManuallySettable: Record<ProspectStatus, true | false> = {
  "new": true,
  "researched": true,
  "sequenced": true,
  "engaged": true,
  "replied": true,
  "meeting_booked": true,
  "converted": false,
  "not_interested": true,
  "do_not_contact": false,
};

export const prospectStatusIsTerminal: Record<ProspectStatus, boolean> = {
  "new": false,
  "researched": false,
  "sequenced": false,
  "engaged": false,
  "replied": false,
  "meeting_booked": false,
  "converted": true,
  "not_interested": true,
  "do_not_contact": true,
};

// ── EnrollmentStatus — source: shared/config/enrollment_statuses.config.json ─
export const ENROLLMENT_STATUS_VALUES = ["active", "paused", "paused_replied", "paused_ooo", "finished_completed", "finished_replied", "finished_bounced", "finished_undeliverable", "finished_opted_out", "finished_converted", "removed"] as const;
export type EnrollmentStatus = (typeof ENROLLMENT_STATUS_VALUES)[number];

export const enrollmentStatusTone: Record<EnrollmentStatus, string> = {
  "active": "success",
  "paused": "warning",
  "paused_replied": "info",
  "paused_ooo": "info",
  "finished_completed": "neutral",
  "finished_replied": "success",
  "finished_bounced": "error",
  "finished_undeliverable": "error",
  "finished_opted_out": "error",
  "finished_converted": "success",
  "removed": "neutral",
};

export const enrollmentStatusTransitions: Record<EnrollmentStatus, EnrollmentStatus[]> = {
  "active": ["paused", "paused_replied", "paused_ooo", "finished_completed", "finished_replied", "finished_bounced", "finished_undeliverable", "finished_opted_out", "finished_converted", "removed"],
  "paused": ["active", "finished_bounced", "finished_undeliverable", "finished_opted_out", "removed"],
  "paused_replied": ["active", "finished_replied", "finished_bounced", "finished_undeliverable", "finished_opted_out", "removed"],
  "paused_ooo": ["active", "finished_bounced", "finished_undeliverable", "finished_opted_out", "removed"],
  "finished_completed": [],
  "finished_replied": [],
  "finished_bounced": [],
  "finished_undeliverable": [],
  "finished_opted_out": [],
  "finished_converted": [],
  "removed": [],
};

export const enrollmentStatusIsTerminal: Record<EnrollmentStatus, boolean> = {
  "active": false,
  "paused": false,
  "paused_replied": false,
  "paused_ooo": false,
  "finished_completed": true,
  "finished_replied": true,
  "finished_bounced": true,
  "finished_undeliverable": true,
  "finished_opted_out": true,
  "finished_converted": true,
  "removed": true,
};

// ── EnrollmentStepStateStatus — source: shared/config/enrollment_step_state_statuses.config.json ─
export const ENROLLMENT_STEP_STATE_STATUS_VALUES = ["pending", "scheduled", "executing", "completed", "skipped", "failed"] as const;
export type EnrollmentStepStateStatus = (typeof ENROLLMENT_STEP_STATE_STATUS_VALUES)[number];

export const enrollmentStepStateStatusTone: Record<EnrollmentStepStateStatus, string> = {
  "pending": "neutral",
  "scheduled": "info",
  "executing": "info",
  "completed": "success",
  "skipped": "neutral",
  "failed": "error",
};

export const enrollmentStepStateStatusIsTerminal: Record<EnrollmentStepStateStatus, boolean> = {
  "pending": false,
  "scheduled": false,
  "executing": false,
  "completed": true,
  "skipped": true,
  "failed": true,
};

// ── OutreachTaskType — source: shared/config/outreach_task_types.config.json ─
export const OUTREACH_TASK_TYPE_VALUES = ["manual_email", "phone_call", "linkedin_view", "linkedin_connect", "linkedin_message", "linkedin_interact", "custom_task"] as const;
export type OutreachTaskType = (typeof OUTREACH_TASK_TYPE_VALUES)[number];

// ── OutreachTaskStatus — source: shared/config/outreach_task_statuses.config.json ─
export const OUTREACH_TASK_STATUS_VALUES = ["pending", "in_progress", "completed", "skipped", "overdue"] as const;
export type OutreachTaskStatus = (typeof OUTREACH_TASK_STATUS_VALUES)[number];

export const outreachTaskStatusTone: Record<OutreachTaskStatus, string> = {
  "pending": "neutral",
  "in_progress": "info",
  "completed": "success",
  "skipped": "neutral",
  "overdue": "error",
};

export const outreachTaskStatusIsTerminal: Record<OutreachTaskStatus, boolean> = {
  "pending": false,
  "in_progress": false,
  "completed": true,
  "skipped": true,
  "overdue": false,
};

// ── ProspectResearchType — source: shared/config/prospect_research_types.config.json ─
export const PROSPECT_RESEARCH_TYPE_VALUES = ["general", "icp_match", "deep_research", "enrichment"] as const;
export type ProspectResearchType = (typeof PROSPECT_RESEARCH_TYPE_VALUES)[number];

// ── CallOutcome — source: shared/config/call_outcomes.config.json ─
export const CALL_OUTCOME_VALUES = ["connected", "voicemail", "no_answer", "wrong_number"] as const;
export type CallOutcome = (typeof CALL_OUTCOME_VALUES)[number];

// ── SequenceOnReplyAction — source: shared/config/sequence_rule_actions.config.json § on_reply ─
export const SEQUENCE_ON_REPLY_ACTION_VALUES = ["pause", "finish", "continue"] as const;
export type SequenceOnReplyAction = (typeof SEQUENCE_ON_REPLY_ACTION_VALUES)[number];

// ── SequenceOnBounceAction — source: shared/config/sequence_rule_actions.config.json § on_bounce ─
export const SEQUENCE_ON_BOUNCE_ACTION_VALUES = ["pause", "finish", "continue", "remove"] as const;
export type SequenceOnBounceAction = (typeof SEQUENCE_ON_BOUNCE_ACTION_VALUES)[number];

// ── SequenceOnOooAction — source: shared/config/sequence_rule_actions.config.json § on_ooo ─
export const SEQUENCE_ON_OOO_ACTION_VALUES = ["pause_and_resume", "pause", "finish", "continue", "remove"] as const;
export type SequenceOnOooAction = (typeof SEQUENCE_ON_OOO_ACTION_VALUES)[number];

// ── SequenceOnMeetingBookedAction — source: shared/config/sequence_rule_actions.config.json § on_meeting_booked ─
export const SEQUENCE_ON_MEETING_BOOKED_ACTION_VALUES = ["finish", "pause", "continue", "remove"] as const;
export type SequenceOnMeetingBookedAction = (typeof SEQUENCE_ON_MEETING_BOOKED_ACTION_VALUES)[number];

// ── EnrichmentJobStatus — source: shared/config/enrichment_job_status.config.json ─
export const ENRICHMENT_JOB_STATUS_VALUES = ["pending", "ready", "collected", "failed", "expired"] as const;
export type EnrichmentJobStatus = (typeof ENRICHMENT_JOB_STATUS_VALUES)[number];

export const enrichmentJobStatusBadgeClass: Record<EnrichmentJobStatus, string> = {
  "pending": "bg-muted text-muted-foreground",
  "ready": "bg-info/10 text-info",
  "collected": "bg-success/10 text-success",
  "failed": "bg-destructive/10 text-destructive",
  "expired": "bg-warning/10 text-warning",
};

export const enrichmentJobStatusColor: Record<EnrichmentJobStatus, string> = {
  "pending": "#64748B",
  "ready": "#3B82F6",
  "collected": "#10B981",
  "failed": "#EF4444",
  "expired": "#D97706",
};

export const enrichmentJobStatusIsTerminal: Record<EnrichmentJobStatus, boolean> = {
  "pending": false,
  "ready": false,
  "collected": true,
  "failed": true,
  "expired": true,
};

// ── TaxTreatment — source: shared/config/tax_treatment.config.json ─
export const TAX_TREATMENT_VALUES = ["standard", "reverse_charge", "intra_eu", "export", "exempt", "zero_rated"] as const;
export type TaxTreatment = (typeof TAX_TREATMENT_VALUES)[number];

// ── VatFilingFrequency — source: shared/config/vat_filing_frequency.config.json ─
export const VAT_FILING_FREQUENCY_VALUES = ["none", "monthly", "quarterly", "annual"] as const;
export type VatFilingFrequency = (typeof VAT_FILING_FREQUENCY_VALUES)[number];

// ── VatScheme — source: shared/config/vat_scheme.config.json ─
export const VAT_SCHEME_VALUES = ["standard", "cash", "flat_rate"] as const;
export type VatScheme = (typeof VAT_SCHEME_VALUES)[number];

// ── EInvoiceFormat — source: shared/config/einvoice_format.config.json ─
export const EINVOICE_FORMAT_VALUES = ["peppol_bis_3_0", "ubl_2_1"] as const;
export type EInvoiceFormat = (typeof EINVOICE_FORMAT_VALUES)[number];

// ── EInvoiceDocumentKind — source: shared/config/einvoice_document_kind.config.json ─
export const EINVOICE_DOCUMENT_KIND_VALUES = ["invoice", "credit_note"] as const;
export type EInvoiceDocumentKind = (typeof EINVOICE_DOCUMENT_KIND_VALUES)[number];

// ── CompanySizeBand — source: shared/config/company_size_band.config.json ─
export const COMPANY_SIZE_BAND_VALUES = ["solo", "micro", "small", "medium", "large", "enterprise"] as const;
export type CompanySizeBand = (typeof COMPANY_SIZE_BAND_VALUES)[number];

export const companySizeBandDefaultVisibilityMode: Record<CompanySizeBand, "everyone" | "owner_and_shared"> = {
  "solo": "everyone",
  "micro": "everyone",
  "small": "everyone",
  "medium": "owner_and_shared",
  "large": "owner_and_shared",
  "enterprise": "owner_and_shared",
};

// ── AiIntakeSourceType — source: shared/config/ai_intake_source_type.config.json ─
export const AI_INTAKE_SOURCE_TYPE_VALUES = ["email", "file", "portal"] as const;
export type AiIntakeSourceType = (typeof AI_INTAKE_SOURCE_TYPE_VALUES)[number];

export const aiIntakeSourceTypeBadgeClass: Record<AiIntakeSourceType, string> = {
  "email": "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  "file": "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
  "portal": "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400",
};

export const aiIntakeSourceTypeColor: Record<AiIntakeSourceType, string> = {
  "email": "#3B82F6",
  "file": "#8B5CF6",
  "portal": "#10B981",
};

export const aiIntakeSourceTypeIcon: Record<AiIntakeSourceType, string> = {
  "email": "Mail",
  "file": "FileText",
  "portal": "Globe",
};

// ── AiIntakeStatus — source: shared/config/ai_intake_status.config.json ─
export const AI_INTAKE_STATUS_VALUES = ["proposed", "approved", "auto_applied", "rejected", "expired"] as const;
export type AiIntakeStatus = (typeof AI_INTAKE_STATUS_VALUES)[number];

export const aiIntakeStatusBadgeClass: Record<AiIntakeStatus, string> = {
  "proposed": "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  "approved": "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400",
  "auto_applied": "bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400",
  "rejected": "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
  "expired": "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400",
};

export const aiIntakeStatusColor: Record<AiIntakeStatus, string> = {
  "proposed": "#3B82F6",
  "approved": "#10B981",
  "auto_applied": "#059669",
  "rejected": "#EF4444",
  "expired": "#6B7280",
};

export const aiIntakeStatusIcon: Record<AiIntakeStatus, string> = {
  "proposed": "Inbox",
  "approved": "CheckCircle2",
  "auto_applied": "Zap",
  "rejected": "XCircle",
  "expired": "Clock",
};

export const aiIntakeStatusTone: Record<AiIntakeStatus, string> = {
  "proposed": "info",
  "approved": "success",
  "auto_applied": "success",
  "rejected": "destructive",
  "expired": "muted",
};

// ── EmailNotificationDraftStatus — source: shared/config/email_notification_draft_status.config.json ─
export const EMAIL_NOTIFICATION_DRAFT_STATUS_VALUES = ["pending_generation", "draft", "sent", "auto_sent", "rejected", "failed"] as const;
export type EmailNotificationDraftStatus = (typeof EMAIL_NOTIFICATION_DRAFT_STATUS_VALUES)[number];

export const emailNotificationDraftStatusBadgeClass: Record<EmailNotificationDraftStatus, string> = {
  "pending_generation": "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400",
  "draft": "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  "sent": "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400",
  "auto_sent": "bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400",
  "rejected": "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
  "failed": "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400",
};

export const emailNotificationDraftStatusColor: Record<EmailNotificationDraftStatus, string> = {
  "pending_generation": "#6B7280",
  "draft": "#3B82F6",
  "sent": "#10B981",
  "auto_sent": "#059669",
  "rejected": "#EF4444",
  "failed": "#F59E0B",
};

export const emailNotificationDraftStatusIcon: Record<EmailNotificationDraftStatus, string> = {
  "pending_generation": "Clock",
  "draft": "Mail",
  "sent": "CheckCircle2",
  "auto_sent": "Zap",
  "rejected": "XCircle",
  "failed": "AlertTriangle",
};

export const emailNotificationDraftStatusTone: Record<EmailNotificationDraftStatus, string> = {
  "pending_generation": "muted",
  "draft": "info",
  "sent": "success",
  "auto_sent": "success",
  "rejected": "destructive",
  "failed": "warning",
};

// ── SendingDomainStatus — source: shared/config/sending_domain_status.config.json ─
export const SENDING_DOMAIN_STATUS_VALUES = ["pending", "records_issued", "verified", "failed"] as const;
export type SendingDomainStatus = (typeof SENDING_DOMAIN_STATUS_VALUES)[number];

export const sendingDomainStatusBadgeClass: Record<SendingDomainStatus, string> = {
  "pending": "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400",
  "records_issued": "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  "verified": "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400",
  "failed": "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
};

export const sendingDomainStatusColor: Record<SendingDomainStatus, string> = {
  "pending": "#6B7280",
  "records_issued": "#3B82F6",
  "verified": "#10B981",
  "failed": "#EF4444",
};

export const sendingDomainStatusIcon: Record<SendingDomainStatus, string> = {
  "pending": "Clock",
  "records_issued": "Globe",
  "verified": "ShieldCheck",
  "failed": "ShieldAlert",
};

export const sendingDomainStatusTone: Record<SendingDomainStatus, string> = {
  "pending": "neutral",
  "records_issued": "info",
  "verified": "success",
  "failed": "error",
};

// ── RevenueRecognitionScheduleStatus — source: shared/config/revenue_recognition_schedule_status.config.json ─
export const REVENUE_RECOGNITION_SCHEDULE_STATUS_VALUES = ["pending", "posted", "cancelled", "reversed"] as const;
export type RevenueRecognitionScheduleStatus = (typeof REVENUE_RECOGNITION_SCHEDULE_STATUS_VALUES)[number];

export const revenueRecognitionScheduleStatusBadgeClass: Record<RevenueRecognitionScheduleStatus, string> = {
  "pending": "bg-warning/10 text-warning",
  "posted": "bg-success/10 text-success",
  "cancelled": "bg-muted text-muted-foreground",
  "reversed": "bg-destructive/10 text-destructive",
};

export const revenueRecognitionScheduleStatusColor: Record<RevenueRecognitionScheduleStatus, string> = {
  "pending": "#F59E0B",
  "posted": "#16A34A",
  "cancelled": "#6B7280",
  "reversed": "#DC2626",
};

// ── ClaimType — source: shared/config/claim_type.config.json ─
export const CLAIM_TYPE_VALUES = ["damage", "loss", "shortage", "delay", "quality", "other"] as const;
export type ClaimType = (typeof CLAIM_TYPE_VALUES)[number];

export const claimTypeBadgeClass: Record<ClaimType, string> = {
  "damage": "bg-destructive/10 text-destructive",
  "loss": "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
  "shortage": "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400",
  "delay": "bg-warning/10 text-warning",
  "quality": "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-400",
  "other": "bg-muted text-muted-foreground",
};

export const claimTypeColor: Record<ClaimType, string> = {
  "damage": "#DC2626",
  "loss": "#9333EA",
  "shortage": "#EA580C",
  "delay": "#D97706",
  "quality": "#0891B2",
  "other": "#6B7280",
};

// ── ClaimDirection — source: shared/config/claim_direction.config.json ─
export const CLAIM_DIRECTION_VALUES = ["ours_against_them", "theirs_against_us"] as const;
export type ClaimDirection = (typeof CLAIM_DIRECTION_VALUES)[number];

export const claimDirectionBadgeClass: Record<ClaimDirection, string> = {
  "ours_against_them": "bg-info/10 text-info",
  "theirs_against_us": "bg-warning/10 text-warning",
};

export const claimDirectionColor: Record<ClaimDirection, string> = {
  "ours_against_them": "#3B82F6",
  "theirs_against_us": "#D97706",
};

// ── ClaimStatus — source: shared/config/claim_status.config.json ─
export const CLAIM_STATUS_VALUES = ["draft", "notified", "filed", "negotiating", "recovered", "written_off", "rejected"] as const;
export type ClaimStatus = (typeof CLAIM_STATUS_VALUES)[number];

export const claimStatusBadgeClass: Record<ClaimStatus, string> = {
  "draft": "bg-muted text-muted-foreground",
  "notified": "bg-info/10 text-info",
  "filed": "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  "negotiating": "bg-warning/10 text-warning",
  "recovered": "bg-success/10 text-success",
  "written_off": "bg-muted text-muted-foreground",
  "rejected": "bg-destructive/10 text-destructive",
};

export const claimStatusColor: Record<ClaimStatus, string> = {
  "draft": "#6B7280",
  "notified": "#3B82F6",
  "filed": "#2563EB",
  "negotiating": "#D97706",
  "recovered": "#16A34A",
  "written_off": "#6B7280",
  "rejected": "#DC2626",
};

export const claimStatusTone: Record<ClaimStatus, string> = {
  "draft": "neutral",
  "notified": "info",
  "filed": "info",
  "negotiating": "warning",
  "recovered": "success",
  "written_off": "neutral",
  "rejected": "error",
};

export const claimStatusIsTerminal: Record<ClaimStatus, boolean> = {
  "draft": false,
  "notified": false,
  "filed": false,
  "negotiating": false,
  "recovered": true,
  "written_off": true,
  "rejected": true,
};

// ── ConversionPlatform — source: shared/config/mkt_conversion_platforms.config.json ─
export const CONVERSION_PLATFORM_VALUES = ["google_ads", "meta_capi"] as const;
export type ConversionPlatform = (typeof CONVERSION_PLATFORM_VALUES)[number];

// ── ConversionTriggerType — source: shared/config/mkt_conversion_trigger_types.config.json ─
export const CONVERSION_TRIGGER_TYPE_VALUES = ["lead_status", "deal_won"] as const;
export type ConversionTriggerType = (typeof CONVERSION_TRIGGER_TYPE_VALUES)[number];

// ── ConversionValueMode — source: shared/config/mkt_conversion_value_modes.config.json ─
export const CONVERSION_VALUE_MODE_VALUES = ["fixed", "deal_amount", "none"] as const;
export type ConversionValueMode = (typeof CONVERSION_VALUE_MODE_VALUES)[number];

// ── ConversionMatchType — source: shared/config/mkt_conversion_match_types.config.json ─
export const CONVERSION_MATCH_TYPE_VALUES = ["click_id", "hashed_pii"] as const;
export type ConversionMatchType = (typeof CONVERSION_MATCH_TYPE_VALUES)[number];

// ── ConversionUploadResult — source: shared/config/mkt_conversion_upload_results.config.json ─
export const CONVERSION_UPLOAD_RESULT_VALUES = ["uploaded", "skipped", "error"] as const;
export type ConversionUploadResult = (typeof CONVERSION_UPLOAD_RESULT_VALUES)[number];

// ── SyncDirection — source: shared/config/sync_direction.config.json ─
export const SYNC_DIRECTION_VALUES = ["inbound", "outbound"] as const;
export type SyncDirection = (typeof SYNC_DIRECTION_VALUES)[number];

// ── SyncRunStatus — source: shared/config/sync_run_status.config.json ─
export const SYNC_RUN_STATUS_VALUES = ["running", "success", "partial", "failed"] as const;
export type SyncRunStatus = (typeof SYNC_RUN_STATUS_VALUES)[number];

// ── SyncRunTrigger — source: shared/config/sync_run_trigger.config.json ─
export const SYNC_RUN_TRIGGER_VALUES = ["manual", "scheduled", "webhook", "event", "seed"] as const;
export type SyncRunTrigger = (typeof SYNC_RUN_TRIGGER_VALUES)[number];

// ── SyncItemAction — source: shared/config/sync_item_action.config.json ─
export const SYNC_ITEM_ACTION_VALUES = ["created", "updated", "deleted", "skipped", "failed"] as const;
export type SyncItemAction = (typeof SYNC_ITEM_ACTION_VALUES)[number];

// ── DedupSuggestionStatus — source: shared/config/dedup_suggestion_status.config.json ─
export const DEDUP_SUGGESTION_STATUS_VALUES = ["pending", "merged", "dismissed"] as const;
export type DedupSuggestionStatus = (typeof DEDUP_SUGGESTION_STATUS_VALUES)[number];

export const dedupSuggestionStatusBadgeClass: Record<DedupSuggestionStatus, string> = {
  "pending": "bg-warning/10 text-warning",
  "merged": "bg-success/10 text-success",
  "dismissed": "bg-muted text-muted-foreground",
};

// ── SyncEntityRole — source: shared/config/sync_entity_roles.config.json ─
export const SYNC_ENTITY_ROLE_VALUES = ["off", "master", "replica", "capture", "replica_capture", "two_way"] as const;
export type SyncEntityRole = (typeof SYNC_ENTITY_ROLE_VALUES)[number];

export const syncEntityRoleBadgeClass: Record<SyncEntityRole, string> = {
  "off": "bg-gray-100 text-gray-700 dark:bg-gray-800/40 dark:text-gray-400",
  "master": "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
  "replica": "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  "capture": "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-400",
  "replica_capture": "bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400",
  "two_way": "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
};

export const syncEntityRoleColor: Record<SyncEntityRole, string> = {
  "off": "#6B7280",
  "master": "#7C3AED",
  "replica": "#2563EB",
  "capture": "#0891B2",
  "replica_capture": "#0D9488",
  "two_way": "#059669",
};

export const syncEntityRoleIcon: Record<SyncEntityRole, string> = {
  "off": "CircleOff",
  "master": "Crown",
  "replica": "ArrowRight",
  "capture": "Download",
  "replica_capture": "ArrowLeftRight",
  "two_way": "RefreshCw",
};

// ── EntitySyncSor — source: shared/config/entity_sync_sor.config.json ─
export const ENTITY_SYNC_SOR_VALUES = ["panluma", "connection"] as const;
export type EntitySyncSor = (typeof ENTITY_SYNC_SOR_VALUES)[number];

export const entitySyncSorBadgeClass: Record<EntitySyncSor, string> = {
  "panluma": "bg-slate-100 text-slate-800 dark:bg-slate-800/40 dark:text-slate-300",
  "connection": "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
};

export const entitySyncSorColor: Record<EntitySyncSor, string> = {
  "panluma": "#334155",
  "connection": "#7C3AED",
};

export const entitySyncSorIcon: Record<EntitySyncSor, string> = {
  "panluma": "Building2",
  "connection": "Plug",
};

// ── PlaidItemHealthStatus — source: shared/config/plaid_item_health.config.json ─
export const PLAID_ITEM_HEALTH_VALUES = ["healthy", "reauth_required", "pending_expiration", "unknown"] as const;
export type PlaidItemHealthStatus = (typeof PLAID_ITEM_HEALTH_VALUES)[number];

export const plaidItemHealthStatusBadgeClass: Record<PlaidItemHealthStatus, string> = {
  "healthy": "border-success/40 text-success",
  "reauth_required": "border-destructive/40 text-destructive",
  "pending_expiration": "border-warning/40 text-warning",
  "unknown": "border-border text-muted-foreground",
};

export const plaidItemHealthStatusIcon: Record<PlaidItemHealthStatus, string> = {
  "healthy": "CheckCircle2",
  "reauth_required": "AlertTriangle",
  "pending_expiration": "Clock",
  "unknown": "HelpCircle",
};

// ── InvReferenceType — source: shared/config/inv_reference_types.config.json ─
export const INV_REFERENCE_TYPE_VALUES = ["purchase_order", "goods_receipt", "sales_order", "adjustment", "transfer", "stock_take", "manual", "sales_order_shipment", "sales_return", "vendor_return", "channel_stock_pull"] as const;
export type InvReferenceType = (typeof INV_REFERENCE_TYPE_VALUES)[number];

// ── ProcUnmatchedReceiptReason — source: shared/config/proc_unmatched_receipt_reasons.config.json ─
export const PROC_UNMATCHED_RECEIPT_REASON_VALUES = ["vendor_shipped_no_po", "sample", "production_output", "found_stock", "other"] as const;
export type ProcUnmatchedReceiptReason = (typeof PROC_UNMATCHED_RECEIPT_REASON_VALUES)[number];

// ── SalesUnmatchedShipmentReason — source: shared/config/sales_unmatched_shipment_reasons.config.json ─
export const SALES_UNMATCHED_SHIPMENT_REASON_VALUES = ["sample_shipment", "warranty_replacement", "internal_use", "customer_pickup_no_so", "other"] as const;
export type SalesUnmatchedShipmentReason = (typeof SALES_UNMATCHED_SHIPMENT_REASON_VALUES)[number];

// ── VendorRole — source: shared/config/vendor_roles.config.json ─
export const VENDOR_ROLE_VALUES = ["supplier", "customs_broker", "drayage_carrier", "ocean_carrier", "air_carrier", "insurance", "origin_agent", "destination_agent", "other"] as const;
export type VendorRole = (typeof VENDOR_ROLE_VALUES)[number];

// ── LandedCostAllocationMethod — source: shared/config/landed_cost_allocation_methods.config.json ─
export const LANDED_COST_ALLOCATION_METHOD_VALUES = ["BY_VALUE", "BY_QUANTITY", "BY_WEIGHT", "BY_VOLUME", "MANUAL"] as const;
export type LandedCostAllocationMethod = (typeof LANDED_COST_ALLOCATION_METHOD_VALUES)[number];

// ── VisibilityMode — source: shared/config/visibility_mode.config.json ─
export const VISIBILITY_MODE_VALUES = ["everyone", "everyone_edit", "owner_and_shared", "team", "custom"] as const;
export type VisibilityMode = (typeof VISIBILITY_MODE_VALUES)[number];

// ── RelationType — source: shared/config/permissions.config.json ─
export const RELATION_VALUES = ["viewer", "commenter", "editor", "owner"] as const;
export type RelationType = (typeof RELATION_VALUES)[number];

export const relationBadgeClass: Record<RelationType, string> = {
  "viewer": "bg-info/10 text-info",
  "commenter": "bg-warning/10 text-warning",
  "editor": "bg-success/10 text-success",
  "owner": "bg-primary/10 text-primary",
};

// ── BankRuleConditionField — source: shared/config/bank_rule_condition_fields.config.json ─
export const BANK_RULE_CONDITION_FIELD_VALUES = ["description", "counterparty", "reference", "amount", "direction"] as const;
export type BankRuleConditionField = (typeof BANK_RULE_CONDITION_FIELD_VALUES)[number];

export const bankRuleConditionFieldGroup: Record<BankRuleConditionField, string> = {
  "description": "text",
  "counterparty": "text",
  "reference": "text",
  "amount": "amount",
  "direction": "direction",
};

// ── BankRuleConditionOperator — source: shared/config/bank_rule_condition_operators.config.json ─
export const BANK_RULE_CONDITION_OPERATOR_VALUES = ["contains", "not_contains", "equals", "starts_with", "regex", "eq", "gt", "gte", "lt", "lte", "between"] as const;
export type BankRuleConditionOperator = (typeof BANK_RULE_CONDITION_OPERATOR_VALUES)[number];

export const bankRuleConditionOperatorGroup: Record<BankRuleConditionOperator, string> = {
  "contains": "text",
  "not_contains": "text",
  "equals": "text",
  "starts_with": "text",
  "regex": "text",
  "eq": "amount",
  "gt": "amount",
  "gte": "amount",
  "lt": "amount",
  "lte": "amount",
  "between": "amount",
};

// ── SuccessCriterionComparison — source: shared/config/success_criterion_comparison.config.json ─
export const SUCCESS_CRITERION_COMPARISON_VALUES = ["gte", "lte", "eq", "gt", "lt"] as const;
export type SuccessCriterionComparison = (typeof SUCCESS_CRITERION_COMPARISON_VALUES)[number];

// ── ShipmentStatus — source: shared/config/shipments.config.json § shipment_statuses ─
export const SHIPMENT_STATUS_VALUES = ["quoted", "draft", "booked", "in_transit", "at_destination", "customs_clearance", "delivered", "closed", "cancelled"] as const;
export type ShipmentStatus = (typeof SHIPMENT_STATUS_VALUES)[number];

export const shipmentStatusTone: Record<ShipmentStatus, string> = {
  "quoted": "neutral",
  "draft": "neutral",
  "booked": "info",
  "in_transit": "info",
  "at_destination": "info",
  "customs_clearance": "warning",
  "delivered": "success",
  "closed": "neutral",
  "cancelled": "error",
};

export const shipmentStatusTransitions: Record<ShipmentStatus, ShipmentStatus[]> = {
  "quoted": ["draft", "booked", "cancelled"],
  "draft": ["booked", "in_transit", "cancelled"],
  "booked": ["in_transit", "cancelled"],
  "in_transit": ["at_destination", "cancelled"],
  "at_destination": ["customs_clearance", "delivered"],
  "customs_clearance": ["delivered"],
  "delivered": ["closed"],
  "closed": [],
  "cancelled": [],
};

// ── ConsolStatus — source: shared/config/shipments.config.json § consol_statuses ─
export const CONSOL_STATUS_VALUES = ["planning", "open", "closed_for_cargo", "departed", "arrived", "deconsolidated", "completed", "cancelled"] as const;
export type ConsolStatus = (typeof CONSOL_STATUS_VALUES)[number];

export const consolStatusTone: Record<ConsolStatus, string> = {
  "planning": "neutral",
  "open": "info",
  "closed_for_cargo": "warning",
  "departed": "info",
  "arrived": "info",
  "deconsolidated": "info",
  "completed": "success",
  "cancelled": "error",
};

export const consolStatusTransitions: Record<ConsolStatus, ConsolStatus[]> = {
  "planning": ["open", "cancelled"],
  "open": ["closed_for_cargo", "cancelled"],
  "closed_for_cargo": ["open", "departed", "cancelled"],
  "departed": ["arrived"],
  "arrived": ["deconsolidated"],
  "deconsolidated": ["completed"],
  "completed": [],
  "cancelled": [],
};

// ── TransportMode — source: shared/config/shipments.config.json § transport_modes ─
export const TRANSPORT_MODE_VALUES = ["AIR", "FCL", "LCL", "FTL", "LTL", "RAIL", "BARGE"] as const;
export type TransportMode = (typeof TRANSPORT_MODE_VALUES)[number];

export const transportModeIcon: Record<TransportMode, string> = {
  "AIR": "Plane",
  "FCL": "Container",
  "LCL": "ContainerPartial",
  "FTL": "Truck",
  "LTL": "TruckPartial",
  "RAIL": "TrainFront",
  "BARGE": "Sailboat",
};

export const transportModeToCategory: Record<TransportMode, "air" | "ocean" | "road" | "rail" | "inland_waterway"> = {
  "AIR": "air",
  "FCL": "ocean",
  "LCL": "ocean",
  "FTL": "road",
  "LTL": "road",
  "RAIL": "rail",
  "BARGE": "inland_waterway",
};

// ── TransportModeCategory — source: shared/config/shipments.config.json § transport_mode_categories ─
export const TRANSPORT_MODE_CATEGORY_VALUES = ["air", "ocean", "road", "rail", "inland_waterway"] as const;
export type TransportModeCategory = (typeof TRANSPORT_MODE_CATEGORY_VALUES)[number];

export const transportModeCategoryIcon: Record<TransportModeCategory, string> = {
  "air": "Plane",
  "ocean": "Ship",
  "road": "Truck",
  "rail": "TrainFront",
  "inland_waterway": "Sailboat",
};

// ── CargoLoadUnitCategory — source: shared/config/shipments.config.json § cargo_load_unit_categories ─
export const CARGO_LOAD_UNIT_CATEGORY_VALUES = ["LOOSE", "CONTAINER", "FTL", "ULD", "SPECIAL"] as const;
export type CargoLoadUnitCategory = (typeof CARGO_LOAD_UNIT_CATEGORY_VALUES)[number];

export const cargoLoadUnitCategoryIcon: Record<CargoLoadUnitCategory, string> = {
  "LOOSE": "Package",
  "CONTAINER": "Container",
  "FTL": "Truck",
  "ULD": "PlaneTakeoff",
  "SPECIAL": "Hexagon",
};

// ── LegStatus — source: shared/config/shipments.config.json § leg_statuses ─
export const LEG_STATUS_VALUES = ["planned", "booked", "departed", "in_transit", "arrived", "completed", "cancelled"] as const;
export type LegStatus = (typeof LEG_STATUS_VALUES)[number];

// ── EtaRevisionType — source: shared/config/shipments.config.json § eta_revision_types ─
export const ETA_REVISION_TYPE_VALUES = ["estimate_revised", "actual_variance"] as const;
export type EtaRevisionType = (typeof ETA_REVISION_TYPE_VALUES)[number];

// ── PartyFunction — source: shared/config/shipments.config.json § party_functions ─
export const PARTY_FUNCTION_VALUES = ["NOTIFY_PARTY", "BUYER", "SELLER", "CUSTOMS_BROKER", "FREIGHT_PAYER", "INSURANCE_HOLDER", "CONSIGNOR_CONTACT", "CONSIGNEE_CONTACT", "CUSTOMER_CONTACT", "SUPPLIER_CONTACT", "SUPPLIER", "OCEAN_CARRIER", "AIR_CARRIER", "DRAYAGE_CARRIER", "ORIGIN_AGENT", "DESTINATION_AGENT", "DELIVER_TO", "DEMURRAGE_PAYER", "FORWARDER", "IMPORTER_OF_RECORD"] as const;
export type PartyFunction = (typeof PARTY_FUNCTION_VALUES)[number];

// ── AssigneeRole — source: shared/config/shipments.config.json § assignee_roles ─
export const ASSIGNEE_ROLE_VALUES = ["COORDINATOR", "DOCUMENTATION", "CUSTOMS", "SALES"] as const;
export type AssigneeRole = (typeof ASSIGNEE_ROLE_VALUES)[number];

// ── PartnerRequestType — source: shared/config/shipments.config.json § partner_request_types ─
export const PARTNER_REQUEST_TYPE_VALUES = ["quote_request", "handoff", "booking_request", "info_request"] as const;
export type PartnerRequestType = (typeof PARTNER_REQUEST_TYPE_VALUES)[number];

export const partnerRequestTypeIcon: Record<PartnerRequestType, string> = {
  "quote_request": "DollarSign",
  "handoff": "Handshake",
  "booking_request": "CalendarCheck",
  "info_request": "MessageSquare",
};

// ── PartnerRequestStatus — source: shared/config/shipments.config.json § partner_request_statuses ─
export const PARTNER_REQUEST_STATUS_VALUES = ["draft", "sent", "responded", "accepted", "declined", "cancelled", "suppressed"] as const;
export type PartnerRequestStatus = (typeof PARTNER_REQUEST_STATUS_VALUES)[number];

export const partnerRequestStatusTransitions: Record<PartnerRequestStatus, PartnerRequestStatus[]> = {
  "draft": ["sent", "suppressed", "cancelled"],
  "sent": ["responded", "cancelled"],
  "responded": ["accepted", "declined", "cancelled"],
  "accepted": [],
  "declined": [],
  "cancelled": [],
  "suppressed": ["sent", "suppressed", "cancelled"],
};

// ── LegHandoffStatus — source: shared/config/shipments.config.json § leg_handoff_statuses ─
export const LEG_HANDOFF_STATUS_VALUES = ["own_office", "offered", "accepted", "in_progress", "completed"] as const;
export type LegHandoffStatus = (typeof LEG_HANDOFF_STATUS_VALUES)[number];

// ── LegVesselChangeSource — source: shared/config/shipments.config.json § leg_vessel_change_sources ─
export const LEG_VESSEL_CHANGE_SOURCE_VALUES = ["schedule", "tracking"] as const;
export type LegVesselChangeSource = (typeof LEG_VESSEL_CHANGE_SOURCE_VALUES)[number];

// ── EtaRevisionChangeType — source: shared/config/shipments.config.json § eta_revision_change_types ─
export const ETA_REVISION_CHANGE_TYPE_VALUES = ["carrier_estimate", "vessel_substitution"] as const;
export type EtaRevisionChangeType = (typeof ETA_REVISION_CHANGE_TYPE_VALUES)[number];

// ── FreightQuoteRequestStatus — source: shared/config/shipments.config.json § freight_quote_request_statuses ─
export const FREIGHT_QUOTE_REQUEST_STATUS_VALUES = ["draft", "sent", "approval_pending", "approved", "awarded", "cancelled"] as const;
export type FreightQuoteRequestStatus = (typeof FREIGHT_QUOTE_REQUEST_STATUS_VALUES)[number];

export const freightQuoteRequestStatusTone: Record<FreightQuoteRequestStatus, string> = {
  "draft": "neutral",
  "sent": "info",
  "approval_pending": "warning",
  "approved": "success",
  "awarded": "success",
  "cancelled": "neutral",
};

export const freightQuoteRequestStatusTransitions: Record<FreightQuoteRequestStatus, FreightQuoteRequestStatus[]> = {
  "draft": ["sent", "approval_pending", "cancelled"],
  "sent": ["approval_pending", "awarded", "cancelled"],
  "approval_pending": ["approved", "sent", "awarded", "cancelled"],
  "approved": ["awarded", "sent", "cancelled"],
  "awarded": [],
  "cancelled": [],
};

// ── FreightQuoteStatus — source: shared/config/shipments.config.json § freight_quote_statuses ─
export const FREIGHT_QUOTE_STATUS_VALUES = ["pending", "sent", "received", "declined", "suppressed"] as const;
export type FreightQuoteStatus = (typeof FREIGHT_QUOTE_STATUS_VALUES)[number];

export const freightQuoteStatusTone: Record<FreightQuoteStatus, string> = {
  "pending": "neutral",
  "sent": "info",
  "received": "success",
  "declined": "neutral",
  "suppressed": "warning",
};

export const freightQuoteStatusTransitions: Record<FreightQuoteStatus, FreightQuoteStatus[]> = {
  "pending": ["sent", "suppressed", "received", "declined"],
  "sent": ["received", "declined"],
  "received": ["declined"],
  "declined": [],
  "suppressed": ["sent", "suppressed", "received", "declined"],
};

// ── FreightQuoteRecipientKind — source: shared/config/shipments.config.json § freight_quote_recipient_kinds ─
export const FREIGHT_QUOTE_RECIPIENT_KIND_VALUES = ["forwarder", "supplier_ddp"] as const;
export type FreightQuoteRecipientKind = (typeof FREIGHT_QUOTE_RECIPIENT_KIND_VALUES)[number];

export const freightQuoteRecipientKindIcon: Record<FreightQuoteRecipientKind, string> = {
  "forwarder": "Truck",
  "supplier_ddp": "Factory",
};

// ── FreightQuoteApprovalStatus — source: shared/config/shipments.config.json § freight_quote_approval_statuses ─
export const FREIGHT_QUOTE_APPROVAL_STATUS_VALUES = ["not_requested", "pending", "approved", "rejected"] as const;
export type FreightQuoteApprovalStatus = (typeof FREIGHT_QUOTE_APPROVAL_STATUS_VALUES)[number];

export const freightQuoteApprovalStatusTone: Record<FreightQuoteApprovalStatus, string> = {
  "not_requested": "neutral",
  "pending": "warning",
  "approved": "success",
  "rejected": "error",
};

// ── FreightQuoteApprovalChannel — source: shared/config/shipments.config.json § freight_quote_approval_channels ─
export const FREIGHT_QUOTE_APPROVAL_CHANNEL_VALUES = ["email", "portal", "internal"] as const;
export type FreightQuoteApprovalChannel = (typeof FREIGHT_QUOTE_APPROVAL_CHANNEL_VALUES)[number];

export const freightQuoteApprovalChannelIcon: Record<FreightQuoteApprovalChannel, string> = {
  "email": "Mail",
  "portal": "Globe",
  "internal": "ClipboardCheck",
};

// ── CustomsFdaStatus — source: shared/config/shipments.config.json § customs_fda_statuses ─
export const CUSTOMS_FDA_STATUS_VALUES = ["not_applicable", "prior_notice_filed", "ok", "review", "hold"] as const;
export type CustomsFdaStatus = (typeof CUSTOMS_FDA_STATUS_VALUES)[number];

export const customsFdaStatusChip: Record<CustomsFdaStatus, "inactive" | "pending" | "completed" | "error"> = {
  "not_applicable": "inactive",
  "prior_notice_filed": "pending",
  "ok": "completed",
  "review": "pending",
  "hold": "error",
};

// ── CustomsRegime — source: shared/config/shipments.config.json § customs_regimes ─
export const CUSTOMS_REGIME_VALUES = ["US_CBP", "EU", "UK", "IL", "CA", "AU"] as const;
export type CustomsRegime = (typeof CUSTOMS_REGIME_VALUES)[number];

// ── CustomsReleaseStatus — source: shared/config/shipments.config.json § customs_release_statuses ─
export const CUSTOMS_RELEASE_STATUS_VALUES = ["pending", "examination", "hold", "rejected", "released"] as const;
export type CustomsReleaseStatus = (typeof CUSTOMS_RELEASE_STATUS_VALUES)[number];

export const customsReleaseStatusChip: Record<CustomsReleaseStatus, "pending" | "error" | "completed"> = {
  "pending": "pending",
  "examination": "pending",
  "hold": "error",
  "rejected": "error",
  "released": "completed",
};

// ── CustomsFilingRegime — source: shared/config/shipments.config.json § customs_filing_regimes ─
export const CUSTOMS_FILING_REGIME_VALUES = ["ISF", "AMS", "ACI", "ENS_ICS2", "AFR", "AES", "ENTRY_7501", "PRIOR_NOTICE"] as const;
export type CustomsFilingRegime = (typeof CUSTOMS_FILING_REGIME_VALUES)[number];

export const customsFilingRegimeDefaultDeadlineBasis: Record<CustomsFilingRegime, "before_loading_24h" | "pre_arrival" | "before_departure_24h"> = {
  "ISF": "before_loading_24h",
  "AMS": "before_loading_24h",
  "ACI": "pre_arrival",
  "ENS_ICS2": "before_loading_24h",
  "AFR": "before_loading_24h",
  "AES": "before_departure_24h",
  "ENTRY_7501": "pre_arrival",
  "PRIOR_NOTICE": "pre_arrival",
};

// ── CustomsFilingStatus — source: shared/config/shipments.config.json § customs_filing_statuses ─
export const CUSTOMS_FILING_STATUS_VALUES = ["pending", "draft", "submitted", "accepted", "rejected", "amended"] as const;
export type CustomsFilingStatus = (typeof CUSTOMS_FILING_STATUS_VALUES)[number];

export const customsFilingStatusChip: Record<CustomsFilingStatus, "pending" | "completed" | "error" | "inactive"> = {
  "pending": "pending",
  "draft": "pending",
  "submitted": "pending",
  "accepted": "completed",
  "rejected": "error",
  "amended": "inactive",
};

// ── CustomsFilingDeadlineBasis — source: shared/config/shipments.config.json § customs_filing_deadline_bases ─
export const CUSTOMS_FILING_DEADLINE_BASIS_VALUES = ["before_loading_24h", "before_departure_24h", "pre_arrival", "manual"] as const;
export type CustomsFilingDeadlineBasis = (typeof CUSTOMS_FILING_DEADLINE_BASIS_VALUES)[number];

export const customsFilingDeadlineBasisReference: Record<CustomsFilingDeadlineBasis, "first_etd" | "last_eta" | "manual"> = {
  "before_loading_24h": "first_etd",
  "before_departure_24h": "first_etd",
  "pre_arrival": "last_eta",
  "manual": "manual",
};

export const customsFilingDeadlineBasisOffsetHours: Record<CustomsFilingDeadlineBasis, -24 | 0> = {
  "before_loading_24h": -24,
  "before_departure_24h": -24,
  "pre_arrival": 0,
  "manual": 0,
};

// ── CustomsFiledBy — source: shared/config/shipments.config.json § customs_filed_by ─
export const CUSTOMS_FILED_BY_VALUES = ["self", "broker", "carrier", "agent"] as const;
export type CustomsFiledBy = (typeof CUSTOMS_FILED_BY_VALUES)[number];

// ── CustomsFilingElementKey — source: shared/config/shipments.config.json § customs_filing_element_keys ─
export const CUSTOMS_FILING_ELEMENT_KEY_VALUES = ["seller", "buyer", "importer_of_record_number", "consignee_number", "manufacturer_supplier", "ship_to_party", "container_stuffing_location", "consolidator", "country_of_origin", "hts_number", "shipper", "consignee", "notify_party", "vessel_voyage", "port_of_loading", "port_of_discharge", "cargo_description", "container_numbers", "seal_numbers", "hbl_number"] as const;
export type CustomsFilingElementKey = (typeof CUSTOMS_FILING_ELEMENT_KEY_VALUES)[number];

export const customsFilingElementKeyKind: Record<CustomsFilingElementKey, "party" | "value"> = {
  "seller": "party",
  "buyer": "party",
  "importer_of_record_number": "value",
  "consignee_number": "value",
  "manufacturer_supplier": "party",
  "ship_to_party": "party",
  "container_stuffing_location": "party",
  "consolidator": "party",
  "country_of_origin": "value",
  "hts_number": "value",
  "shipper": "party",
  "consignee": "party",
  "notify_party": "party",
  "vessel_voyage": "value",
  "port_of_loading": "value",
  "port_of_discharge": "value",
  "cargo_description": "value",
  "container_numbers": "value",
  "seal_numbers": "value",
  "hbl_number": "value",
};

// ── CustomsFilingElementSource — source: shared/config/shipments.config.json § customs_filing_element_sources ─
export const CUSTOMS_FILING_ELEMENT_SOURCE_VALUES = ["derived", "manual", "document"] as const;
export type CustomsFilingElementSource = (typeof CUSTOMS_FILING_ELEMENT_SOURCE_VALUES)[number];

// ── CustomsHoldType — source: shared/config/shipments.config.json § customs_hold_types ─
export const CUSTOMS_HOLD_TYPE_VALUES = ["pga_fda", "pga_usda", "pga_other", "manifest", "commercial", "exam_nii", "exam_intensive"] as const;
export type CustomsHoldType = (typeof CUSTOMS_HOLD_TYPE_VALUES)[number];

export const customsHoldTypeCategory: Record<CustomsHoldType, "pga" | "hold" | "exam"> = {
  "pga_fda": "pga",
  "pga_usda": "pga",
  "pga_other": "pga",
  "manifest": "hold",
  "commercial": "hold",
  "exam_nii": "exam",
  "exam_intensive": "exam",
};

// ── CustomsInbondType — source: shared/config/shipments.config.json § customs_inbond_types ─
export const CUSTOMS_INBOND_TYPE_VALUES = ["IT_61", "TE_62", "IE_63"] as const;
export type CustomsInbondType = (typeof CUSTOMS_INBOND_TYPE_VALUES)[number];

// ── CustomsDispositionCategory — source: shared/config/shipments.config.json § customs_disposition_categories ─
export const CUSTOMS_DISPOSITION_CATEGORY_VALUES = ["cbp", "fda", "pga_other"] as const;
export type CustomsDispositionCategory = (typeof CUSTOMS_DISPOSITION_CATEGORY_VALUES)[number];

export const customsDispositionCategoryChip: Record<CustomsDispositionCategory, "info"> = {
  "cbp": "info",
  "fda": "info",
  "pga_other": "info",
};

// ── CustomsEntryLineType — source: shared/config/shipments.config.json § customs_entry_line_types ─
export const CUSTOMS_ENTRY_LINE_TYPE_VALUES = ["base_hts", "duty_addon", "fee_mpf", "fee_hmf", "fee_other"] as const;
export type CustomsEntryLineType = (typeof CUSTOMS_ENTRY_LINE_TYPE_VALUES)[number];

// ── CustomsDutyProgram — source: shared/config/shipments.config.json § customs_duty_programs ─
export const CUSTOMS_DUTY_PROGRAM_VALUES = ["section_301", "section_232", "section_122", "other"] as const;
export type CustomsDutyProgram = (typeof CUSTOMS_DUTY_PROGRAM_VALUES)[number];

// ── DndChargeType — source: shared/config/shipments.config.json § dnd_charge_types ─
export const DND_CHARGE_TYPE_VALUES = ["demurrage", "detention", "storage", "combined"] as const;
export type DndChargeType = (typeof DND_CHARGE_TYPE_VALUES)[number];

// ── DndClockStatus — source: shared/config/shipments.config.json § dnd_clock_statuses ─
export const DND_CLOCK_STATUS_VALUES = ["within_free", "at_risk", "accruing", "closed", "disputed"] as const;
export type DndClockStatus = (typeof DND_CLOCK_STATUS_VALUES)[number];

export const dndClockStatusColor: Record<DndClockStatus, string> = {
  "within_free": "#6B7280",
  "at_risk": "#EA580C",
  "accruing": "#DC2626",
  "closed": "#16A34A",
  "disputed": "#7C3AED",
};

// ── DndDisputeStatus — source: shared/config/shipments.config.json § dnd_dispute_statuses ─
export const DND_DISPUTE_STATUS_VALUES = ["open", "accepted", "rejected", "settled"] as const;
export type DndDisputeStatus = (typeof DND_DISPUTE_STATUS_VALUES)[number];

export const dndDisputeStatusColor: Record<DndDisputeStatus, string> = {
  "open": "#EA580C",
  "accepted": "#16A34A",
  "rejected": "#DC2626",
  "settled": "#6B7280",
};

// ── CfsReceiptStatus — source: shared/config/shipments.config.json § cfs_receipt_statuses ─
export const CFS_RECEIPT_STATUS_VALUES = ["draft", "received", "in_storage", "released", "cancelled"] as const;
export type CfsReceiptStatus = (typeof CFS_RECEIPT_STATUS_VALUES)[number];

export const cfsReceiptStatusColor: Record<CfsReceiptStatus, string> = {
  "draft": "#6B7280",
  "received": "#0EA5E9",
  "in_storage": "#EA580C",
  "released": "#16A34A",
  "cancelled": "#DC2626",
};

export const cfsReceiptStatusTransitions: Record<CfsReceiptStatus, CfsReceiptStatus[]> = {
  "draft": ["received", "cancelled"],
  "received": ["in_storage", "cancelled"],
  "in_storage": ["released", "cancelled"],
  "released": [],
  "cancelled": [],
};

// ── CfsReceiptType — source: shared/config/shipments.config.json § cfs_receipt_types ─
export const CFS_RECEIPT_TYPE_VALUES = ["warehouse_receipt", "dock_receipt"] as const;
export type CfsReceiptType = (typeof CFS_RECEIPT_TYPE_VALUES)[number];

// ── CfsDirection — source: shared/config/shipments.config.json § cfs_directions ─
export const CFS_DIRECTION_VALUES = ["inbound_export", "inbound_import"] as const;
export type CfsDirection = (typeof CFS_DIRECTION_VALUES)[number];

// ── CfsPackageCondition — source: shared/config/shipments.config.json § cfs_package_conditions ─
export const CFS_PACKAGE_CONDITION_VALUES = ["good", "damaged", "short", "over"] as const;
export type CfsPackageCondition = (typeof CFS_PACKAGE_CONDITION_VALUES)[number];

export const cfsPackageConditionColor: Record<CfsPackageCondition, string> = {
  "good": "#16A34A",
  "damaged": "#DC2626",
  "short": "#EA580C",
  "over": "#7C3AED",
};

// ── CfsPackageStatus — source: shared/config/shipments.config.json § cfs_package_statuses ─
export const CFS_PACKAGE_STATUS_VALUES = ["in_storage", "staged", "loaded_out", "released"] as const;
export type CfsPackageStatus = (typeof CFS_PACKAGE_STATUS_VALUES)[number];

export const cfsPackageStatusColor: Record<CfsPackageStatus, string> = {
  "in_storage": "#EA580C",
  "staged": "#0EA5E9",
  "loaded_out": "#6B7280",
  "released": "#16A34A",
};

// ── CfsEventType — source: shared/config/shipments.config.json § cfs_event_types ─
export const CFS_EVENT_TYPE_VALUES = ["received", "put_away", "moved", "held", "released_hold", "attached", "detached", "staged", "loaded_out", "released"] as const;
export type CfsEventType = (typeof CFS_EVENT_TYPE_VALUES)[number];

// ── CfsDayBasis — source: shared/config/shipments.config.json § cfs_day_bases ─
export const CFS_DAY_BASIS_VALUES = ["calendar", "working"] as const;
export type CfsDayBasis = (typeof CFS_DAY_BASIS_VALUES)[number];

// ── CfsRateBasis — source: shared/config/shipments.config.json § cfs_rate_bases ─
export const CFS_RATE_BASIS_VALUES = ["per_cbm_day", "per_pallet_day", "per_ton_day", "per_receipt_day"] as const;
export type CfsRateBasis = (typeof CFS_RATE_BASIS_VALUES)[number];

// ── CfsStorageClockStatus — source: shared/config/shipments.config.json § cfs_storage_clock_statuses ─
export const CFS_STORAGE_CLOCK_STATUS_VALUES = ["within_free", "accruing", "closed"] as const;
export type CfsStorageClockStatus = (typeof CFS_STORAGE_CLOCK_STATUS_VALUES)[number];

export const cfsStorageClockStatusColor: Record<CfsStorageClockStatus, string> = {
  "within_free": "#6B7280",
  "accruing": "#DC2626",
  "closed": "#16A34A",
};

// ── CutoffType — source: shared/config/shipments.config.json § cutoff_types ─
export const CUTOFF_TYPE_VALUES = ["CARGO", "DOCUMENTATION", "SI", "VGM", "AMS", "DG"] as const;
export type CutoffType = (typeof CUTOFF_TYPE_VALUES)[number];

// ── CutoffFulfillmentStatus — source: shared/config/shipments.config.json § cutoff_fulfillment_statuses ─
export const CUTOFF_FULFILLMENT_STATUS_VALUES = ["pending", "submitted", "confirmed", "waived"] as const;
export type CutoffFulfillmentStatus = (typeof CUTOFF_FULFILLMENT_STATUS_VALUES)[number];

export const cutoffFulfillmentStatusColor: Record<CutoffFulfillmentStatus, string> = {
  "pending": "#6B7280",
  "submitted": "#2563EB",
  "confirmed": "#16A34A",
  "waived": "#6B7280",
};

export const cutoffFulfillmentStatusTone: Record<CutoffFulfillmentStatus, string> = {
  "pending": "neutral",
  "submitted": "info",
  "confirmed": "success",
  "waived": "neutral",
};

// ── ShipmentExternalRefType — source: shared/config/shipment_external_ref_types.config.json ─
export const SHIPMENT_EXTERNAL_REF_TYPE_VALUES = ["booking_no", "bl_no", "container_no", "awb_no", "provider_shipment_id", "broker_file_no", "isf_no", "entry_no", "supplier_pi_no", "supplier_ci_no"] as const;
export type ShipmentExternalRefType = (typeof SHIPMENT_EXTERNAL_REF_TYPE_VALUES)[number];

// ── ScheduleMode — source: shared/config/shipments.config.json § schedule_modes ─
export const SCHEDULE_MODE_VALUES = ["OCEAN", "AIR"] as const;
export type ScheduleMode = (typeof SCHEDULE_MODE_VALUES)[number];

// ── ScheduleSource — source: shared/config/shipments.config.json § schedule_sources ─
export const SCHEDULE_SOURCE_VALUES = ["MANUAL", "CSV", "API"] as const;
export type ScheduleSource = (typeof SCHEDULE_SOURCE_VALUES)[number];

// ── ScheduleProvider — source: shared/config/shipments.config.json § schedule_providers ─
export const SCHEDULE_PROVIDER_VALUES = ["manual"] as const;
export type ScheduleProvider = (typeof SCHEDULE_PROVIDER_VALUES)[number];

// ── CarrierMessageType — source: shared/config/shipments.config.json § carrier_message_types ─
export const CARRIER_MESSAGE_TYPE_VALUES = ["booking_request", "shipping_instruction", "vgm", "fwb", "fhl"] as const;
export type CarrierMessageType = (typeof CARRIER_MESSAGE_TYPE_VALUES)[number];

export const carrierMessageTypeIcon: Record<CarrierMessageType, string> = {
  "booking_request": "CalendarPlus",
  "shipping_instruction": "FileText",
  "vgm": "Weight",
  "fwb": "Plane",
  "fhl": "Layers",
};

// ── CarrierMessageStatus — source: shared/config/shipments.config.json § carrier_message_statuses ─
export const CARRIER_MESSAGE_STATUS_VALUES = ["draft", "ready", "transmitted", "confirmed", "declined", "failed", "amended"] as const;
export type CarrierMessageStatus = (typeof CARRIER_MESSAGE_STATUS_VALUES)[number];

export const carrierMessageStatusColor: Record<CarrierMessageStatus, string> = {
  "draft": "#6B7280",
  "ready": "#2563EB",
  "transmitted": "#7C3AED",
  "confirmed": "#16A34A",
  "declined": "#DC2626",
  "failed": "#DC2626",
  "amended": "#D97706",
};

export const carrierMessageStatusTone: Record<CarrierMessageStatus, string> = {
  "draft": "neutral",
  "ready": "info",
  "transmitted": "info",
  "confirmed": "success",
  "declined": "destructive",
  "failed": "destructive",
  "amended": "warning",
};

export const carrierMessageStatusTransitions: Record<CarrierMessageStatus, CarrierMessageStatus[]> = {
  "draft": ["ready"],
  "ready": ["draft", "transmitted"],
  "transmitted": ["confirmed", "declined", "failed"],
  "confirmed": ["amended"],
  "declined": ["amended"],
  "failed": ["ready"],
  "amended": ["ready"],
};

// ── CarrierMessageEventType — source: shared/config/shipments.config.json § carrier_message_event_types ─
export const CARRIER_MESSAGE_EVENT_TYPE_VALUES = ["created", "marked_ready", "reopened", "transmitted", "confirmed", "declined", "failed", "amended"] as const;
export type CarrierMessageEventType = (typeof CARRIER_MESSAGE_EVENT_TYPE_VALUES)[number];

// ── CarrierMessagingProvider — source: shared/config/shipments.config.json § carrier_messaging_providers ─
export const CARRIER_MESSAGING_PROVIDER_VALUES = ["manual"] as const;
export type CarrierMessagingProvider = (typeof CARRIER_MESSAGING_PROVIDER_VALUES)[number];

// ── TerminalAppointmentMoveType — source: shared/config/shipments.config.json § terminal_appointment_move_types ─
export const TERMINAL_APPOINTMENT_MOVE_TYPE_VALUES = ["pickup_full", "return_empty", "dual"] as const;
export type TerminalAppointmentMoveType = (typeof TERMINAL_APPOINTMENT_MOVE_TYPE_VALUES)[number];

// ── TerminalAppointmentStatus — source: shared/config/shipments.config.json § terminal_appointment_statuses ─
export const TERMINAL_APPOINTMENT_STATUS_VALUES = ["requested", "confirmed", "missed", "completed"] as const;
export type TerminalAppointmentStatus = (typeof TERMINAL_APPOINTMENT_STATUS_VALUES)[number];

export const terminalAppointmentStatusColor: Record<TerminalAppointmentStatus, string> = {
  "requested": "#EA580C",
  "confirmed": "#2563EB",
  "missed": "#DC2626",
  "completed": "#16A34A",
};

// ── ChassisProvider — source: shared/config/shipments.config.json § chassis_providers ─
export const CHASSIS_PROVIDER_VALUES = ["pool", "carrier", "own"] as const;
export type ChassisProvider = (typeof CHASSIS_PROVIDER_VALUES)[number];

// ── StreetTurnStatus — source: shared/config/shipments.config.json § street_turn_statuses ─
export const STREET_TURN_STATUS_VALUES = ["requested", "approved", "rejected", "completed"] as const;
export type StreetTurnStatus = (typeof STREET_TURN_STATUS_VALUES)[number];

export const streetTurnStatusColor: Record<StreetTurnStatus, string> = {
  "requested": "#EA580C",
  "approved": "#2563EB",
  "rejected": "#DC2626",
  "completed": "#16A34A",
};

// ── ExportLicenseType — source: shared/config/shipments.config.json § export_license_types ─
export const EXPORT_LICENSE_TYPE_VALUES = ["nlr", "license", "exception"] as const;
export type ExportLicenseType = (typeof EXPORT_LICENSE_TYPE_VALUES)[number];

export const exportLicenseTypeColor: Record<ExportLicenseType, string> = {
  "nlr": "#16A34A",
  "license": "#2563EB",
  "exception": "#EA580C",
};

// ── ExportLicenseExceptionCode — source: shared/config/shipments.config.json § export_license_exception_codes ─
export const EXPORT_LICENSE_EXCEPTION_CODE_VALUES = ["LVS", "GBS", "CIV", "TSR", "TMP", "RPL", "GOV", "GFT", "TSU", "BAG", "AVS", "APR", "ENC", "AGR", "STA", "CCD"] as const;
export type ExportLicenseExceptionCode = (typeof EXPORT_LICENSE_EXCEPTION_CODE_VALUES)[number];

// ── DgRegulation — source: shared/config/shipments.config.json § dg_regulations ─
export const DG_REGULATION_VALUES = ["imdg", "iata_dgr", "adr"] as const;
export type DgRegulation = (typeof DG_REGULATION_VALUES)[number];

export const dgRegulationColor: Record<DgRegulation, string> = {
  "imdg": "#2563EB",
  "iata_dgr": "#7C3AED",
  "adr": "#0891B2",
};

// ── DgDeclarationStatus — source: shared/config/shipments.config.json § dg_declaration_statuses ─
export const DG_DECLARATION_STATUS_VALUES = ["draft", "signed"] as const;
export type DgDeclarationStatus = (typeof DG_DECLARATION_STATUS_VALUES)[number];

export const dgDeclarationStatusColor: Record<DgDeclarationStatus, string> = {
  "draft": "#64748B",
  "signed": "#16A34A",
};

// ── DgClass — source: shared/config/shipments.config.json § dg_classes ─
export const DG_CLASS_VALUES = ["1.1", "1.2", "1.3", "1.4", "1.5", "1.6", "2.1", "2.2", "2.3", "3", "4.1", "4.2", "4.3", "5.1", "5.2", "6.1", "6.2", "7", "8", "9"] as const;
export type DgClass = (typeof DG_CLASS_VALUES)[number];

// ── DgPackingGroup — source: shared/config/shipments.config.json § dg_packing_groups ─
export const DG_PACKING_GROUP_VALUES = ["I", "II", "III"] as const;
export type DgPackingGroup = (typeof DG_PACKING_GROUP_VALUES)[number];

export const dgPackingGroupColor: Record<DgPackingGroup, string> = {
  "I": "#DC2626",
  "II": "#EA580C",
  "III": "#CA8A04",
};

// ── DgQuantityUnit — source: shared/config/shipments.config.json § dg_quantity_units ─
export const DG_QUANTITY_UNIT_VALUES = ["kg", "L"] as const;
export type DgQuantityUnit = (typeof DG_QUANTITY_UNIT_VALUES)[number];

// ── FreetimeScopeType — source: shared/config/shipments.config.json § freetime_scope_types ─
export const FREETIME_SCOPE_TYPE_VALUES = ["carrier", "contract", "customer", "port", "default"] as const;
export type FreetimeScopeType = (typeof FREETIME_SCOPE_TYPE_VALUES)[number];

// ── FreetimeDayBasis — source: shared/config/shipments.config.json § freetime_day_bases ─
export const FREETIME_DAY_BASIS_VALUES = ["calendar", "working"] as const;
export type FreetimeDayBasis = (typeof FREETIME_DAY_BASIS_VALUES)[number];

// ── ContainerType — source: shared/config/shipments.config.json § container_types ─
export const CONTAINER_TYPE_VALUES = ["DRY", "REEFER", "OPEN_TOP", "FLAT_RACK", "TANK", "BULK", "VENTILATED", "INSULATED", "PLATFORM"] as const;
export type ContainerType = (typeof CONTAINER_TYPE_VALUES)[number];

// ── MilestoneSource — source: shared/config/shipments.config.json § milestone_sources ─
export const MILESTONE_SOURCE_VALUES = ["MANUAL", "CARRIER_EDI", "API", "AGENT", "TEMPLATE"] as const;
export type MilestoneSource = (typeof MILESTONE_SOURCE_VALUES)[number];

// ── ExceptionType — source: shared/config/shipments.config.json § exception_types ─
export const EXCEPTION_TYPE_VALUES = ["ROLLOVER", "CUSTOMS_HOLD", "CARGO_DAMAGE", "DELAY", "DOCUMENTATION", "DEMURRAGE", "BLANK_SAILING", "ETA_SLIP", "COMPLIANCE", "MARGIN_EROSION", "MILESTONE_GAP", "MISSING_DOCUMENT", "CUTOFF_RISK", "BL_RELEASE_GATE", "TRACKING_SILENCE", "TRANSSHIP_MISS", "FILING_RISK", "UNINSURED_CARGO"] as const;
export type ExceptionType = (typeof EXCEPTION_TYPE_VALUES)[number];

// ── ExceptionSeverity — source: shared/config/shipments.config.json § exception_severities ─
export const EXCEPTION_SEVERITY_VALUES = ["CRITICAL", "MAJOR", "MINOR"] as const;
export type ExceptionSeverity = (typeof EXCEPTION_SEVERITY_VALUES)[number];

export const exceptionSeverityColor: Record<ExceptionSeverity, string> = {
  "CRITICAL": "#DC2626",
  "MAJOR": "#EA580C",
  "MINOR": "#6B7280",
};

export const exceptionSeverityTone: Record<ExceptionSeverity, string> = {
  "CRITICAL": "error",
  "MAJOR": "warning",
  "MINOR": "neutral",
};

// ── ExceptionStatus — source: shared/config/shipments.config.json § exception_statuses ─
export const EXCEPTION_STATUS_VALUES = ["new", "acknowledged", "in_progress", "resolved", "dismissed"] as const;
export type ExceptionStatus = (typeof EXCEPTION_STATUS_VALUES)[number];

export const exceptionStatusTone: Record<ExceptionStatus, string> = {
  "new": "error",
  "acknowledged": "warning",
  "in_progress": "info",
  "resolved": "success",
  "dismissed": "neutral",
};

export const exceptionStatusTransitions: Record<ExceptionStatus, ExceptionStatus[]> = {
  "new": ["acknowledged", "in_progress", "resolved", "dismissed"],
  "acknowledged": ["in_progress", "resolved", "dismissed"],
  "in_progress": ["resolved", "dismissed"],
  "resolved": [],
  "dismissed": [],
};

export const exceptionStatusIsTerminal: Record<ExceptionStatus, boolean> = {
  "new": false,
  "acknowledged": false,
  "in_progress": false,
  "resolved": true,
  "dismissed": true,
};

// ── CoverageStatus — source: shared/config/shipments.config.json § coverage_statuses ─
export const COVERAGE_STATUS_VALUES = ["not_required", "required", "requested", "covered", "expired", "declined"] as const;
export type CoverageStatus = (typeof COVERAGE_STATUS_VALUES)[number];

export const coverageStatusTone: Record<CoverageStatus, string> = {
  "not_required": "neutral",
  "required": "warning",
  "requested": "info",
  "covered": "success",
  "expired": "warning",
  "declined": "error",
};

export const coverageStatusTransitions: Record<CoverageStatus, CoverageStatus[]> = {
  "not_required": ["required", "covered"],
  "required": ["not_required", "requested", "covered", "declined"],
  "requested": ["required", "covered", "declined"],
  "covered": ["expired", "not_required"],
  "expired": ["required", "requested", "covered"],
  "declined": ["required", "requested", "covered"],
};

// ── InsuredValueBasis — source: shared/config/shipments.config.json § insured_value_bases ─
export const INSURED_VALUE_BASIS_VALUES = ["cif_plus_uplift", "goods_value", "manual"] as const;
export type InsuredValueBasis = (typeof INSURED_VALUE_BASIS_VALUES)[number];

// ── DeniedPartySourceList — source: shared/config/denied_party_source_list.config.json ─
export const DENIED_PARTY_SOURCE_LIST_VALUES = ["OFAC_SDN", "BIS_ENTITY", "EU_CFSP", "UN"] as const;
export type DeniedPartySourceList = (typeof DENIED_PARTY_SOURCE_LIST_VALUES)[number];

// ── ScreeningMatchStatus — source: shared/config/screening_match_status.config.json ─
export const SCREENING_MATCH_STATUS_VALUES = ["clear", "potential", "blocked"] as const;
export type ScreeningMatchStatus = (typeof SCREENING_MATCH_STATUS_VALUES)[number];

// ── ScreeningDisposition — source: shared/config/screening_disposition.config.json ─
export const SCREENING_DISPOSITION_VALUES = ["pending", "false_positive", "confirmed"] as const;
export type ScreeningDisposition = (typeof SCREENING_DISPOSITION_VALUES)[number];

// ── ApMatchVerdict — source: shared/config/ap_match_verdict.config.json ─
export const AP_MATCH_VERDICT_VALUES = ["matched", "within_tolerance", "over_tolerance", "under_tolerance", "unmatched", "fx_unavailable"] as const;
export type ApMatchVerdict = (typeof AP_MATCH_VERDICT_VALUES)[number];

export const apMatchVerdictBadgeClass: Record<ApMatchVerdict, string> = {
  "matched": "bg-success/10 text-success",
  "within_tolerance": "bg-info/10 text-info",
  "over_tolerance": "bg-destructive/10 text-destructive",
  "under_tolerance": "bg-warning/10 text-warning",
  "unmatched": "bg-warning/10 text-warning",
  "fx_unavailable": "bg-destructive/10 text-destructive",
};

// ── ApMatchSourceKind — source: shared/config/ap_match_source_kind.config.json ─
export const AP_MATCH_SOURCE_KIND_VALUES = ["purchase_order", "shipment_charge", "mixed", "none"] as const;
export type ApMatchSourceKind = (typeof AP_MATCH_SOURCE_KIND_VALUES)[number];

// ── ApAuditStatus — source: shared/config/ap_audit_status.config.json ─
export const AP_AUDIT_STATUS_VALUES = ["open", "resolved", "dismissed"] as const;
export type ApAuditStatus = (typeof AP_AUDIT_STATUS_VALUES)[number];

// ── VendorStatementKind — source: shared/config/vendor_statement_kind.config.json ─
export const VENDOR_STATEMENT_KIND_VALUES = ["soa", "cass"] as const;
export type VendorStatementKind = (typeof VENDOR_STATEMENT_KIND_VALUES)[number];

// ── VendorStatementStatus — source: shared/config/vendor_statement_status.config.json ─
export const VENDOR_STATEMENT_STATUS_VALUES = ["imported", "reconciled", "reviewed"] as const;
export type VendorStatementStatus = (typeof VENDOR_STATEMENT_STATUS_VALUES)[number];

// ── VendorStatementMatchStatus — source: shared/config/vendor_statement_match_status.config.json ─
export const VENDOR_STATEMENT_MATCH_STATUS_VALUES = ["unreconciled", "matched", "discrepant", "unmatched"] as const;
export type VendorStatementMatchStatus = (typeof VENDOR_STATEMENT_MATCH_STATUS_VALUES)[number];

// ── TicketStatus — source: shared/config/ticket_statuses.config.json ─
export const TICKET_STATUS_VALUES = ["new", "open", "pending", "on_hold", "resolved", "closed"] as const;
export type TicketStatus = (typeof TICKET_STATUS_VALUES)[number];

export const ticketStatusBadgeClass: Record<TicketStatus, string> = {
  "new": "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200",
  "open": "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
  "pending": "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
  "on_hold": "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200",
  "resolved": "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  "closed": "bg-muted text-muted-foreground",
};

export const ticketStatusColor: Record<TicketStatus, string> = {
  "new": "#A855F7",
  "open": "#3B82F6",
  "pending": "#EAB308",
  "on_hold": "#F97316",
  "resolved": "#10B981",
  "closed": "#6B7280",
};

export const ticketStatusTone: Record<TicketStatus, string> = {
  "new": "neutral",
  "open": "info",
  "pending": "warning",
  "on_hold": "warning",
  "resolved": "success",
  "closed": "neutral",
};

// ── TicketPriority — source: shared/config/ticket_priorities.config.json ─
export const TICKET_PRIORITY_VALUES = ["critical", "high", "medium", "low", "enhancement"] as const;
export type TicketPriority = (typeof TICKET_PRIORITY_VALUES)[number];

export const ticketPriorityBadgeClass: Record<TicketPriority, string> = {
  "critical": "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
  "high": "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200",
  "medium": "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
  "low": "bg-muted text-muted-foreground",
  "enhancement": "bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-200",
};

export const ticketPriorityColor: Record<TicketPriority, string> = {
  "critical": "#DC2626",
  "high": "#EA580C",
  "medium": "#2563EB",
  "low": "#6B7280",
  "enhancement": "#059669",
};

// ── TicketChannel — source: shared/config/ticket_channels.config.json ─
export const TICKET_CHANNEL_VALUES = ["email", "portal", "chat", "whatsapp", "phone", "api", "internal", "widget"] as const;
export type TicketChannel = (typeof TICKET_CHANNEL_VALUES)[number];

export const ticketChannelBadgeClass: Record<TicketChannel, string> = {
  "email": "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
  "portal": "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200",
  "chat": "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  "whatsapp": "bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-200",
  "phone": "bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200",
  "api": "bg-muted text-muted-foreground",
  "internal": "bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200",
  "widget": "bg-sky-100 text-sky-800 dark:bg-sky-900 dark:text-sky-200",
};

export const ticketChannelColor: Record<TicketChannel, string> = {
  "email": "#3B82F6",
  "portal": "#8B5CF6",
  "chat": "#10B981",
  "whatsapp": "#22C55E",
  "phone": "#F59E0B",
  "api": "#6B7280",
  "internal": "#64748B",
  "widget": "#0EA5E9",
};

export const ticketChannelIcon: Record<TicketChannel, string> = {
  "email": "Mail",
  "portal": "Globe",
  "chat": "MessageSquare",
  "whatsapp": "MessageCircle",
  "phone": "Phone",
  "api": "Code",
  "internal": "Building2",
  "widget": "MessageSquareDot",
};

// ── OnboardingCategory — source: shared/config/onboarding_category.config.json ─
export const ONBOARDING_CATEGORY_VALUES = ["it_setup", "paperwork", "training", "introduction", "asset_return", "access_revocation", "exit_interview", "final_pay", "handover", "general"] as const;
export type OnboardingCategory = (typeof ONBOARDING_CATEGORY_VALUES)[number];

export const onboardingCategoryKind: Record<OnboardingCategory, "onboarding" | "offboarding" | "both"> = {
  "it_setup": "onboarding",
  "paperwork": "onboarding",
  "training": "onboarding",
  "introduction": "onboarding",
  "asset_return": "offboarding",
  "access_revocation": "offboarding",
  "exit_interview": "offboarding",
  "final_pay": "offboarding",
  "handover": "offboarding",
  "general": "both",
};

// ── ChecklistKind — source: shared/config/checklist_kind.config.json ─
export const CHECKLIST_KIND_VALUES = ["onboarding", "offboarding"] as const;
export type ChecklistKind = (typeof CHECKLIST_KIND_VALUES)[number];

// ── OnboardingRole — source: shared/config/onboarding_role.config.json ─
export const ONBOARDING_ROLE_VALUES = ["manager", "hr", "it", "employee", "buddy"] as const;
export type OnboardingRole = (typeof ONBOARDING_ROLE_VALUES)[number];

// ── LeaveType — source: shared/config/leave_type.config.json ─
export const LEAVE_TYPE_VALUES = ["annual", "sick", "personal", "parental", "bereavement", "unpaid", "other"] as const;
export type LeaveType = (typeof LEAVE_TYPE_VALUES)[number];

// ── EmploymentType — source: shared/config/employment_type.config.json ─
export const EMPLOYMENT_TYPE_VALUES = ["full_time", "part_time", "contractor", "intern", "temporary"] as const;
export type EmploymentType = (typeof EMPLOYMENT_TYPE_VALUES)[number];

// ── EmploymentStatus — source: shared/config/employment_status.config.json ─
export const EMPLOYMENT_STATUS_VALUES = ["active", "on_leave", "terminated"] as const;
export type EmploymentStatus = (typeof EMPLOYMENT_STATUS_VALUES)[number];

export const employmentStatusTone: Record<EmploymentStatus, string> = {
  "active": "success",
  "on_leave": "warning",
  "terminated": "neutral",
};

// ── FlsaStatus — source: shared/config/flsa_status.config.json ─
export const FLSA_STATUS_VALUES = ["exempt", "non_exempt"] as const;
export type FlsaStatus = (typeof FLSA_STATUS_VALUES)[number];

// ── TerminationReason — source: shared/config/termination_reason.config.json ─
export const TERMINATION_REASON_VALUES = ["voluntary", "involuntary", "retirement", "end_of_contract", "mutual_agreement", "other"] as const;
export type TerminationReason = (typeof TERMINATION_REASON_VALUES)[number];

// ── Honorific — source: shared/config/honorific.config.json ─
export const HONORIFIC_VALUES = ["mr", "mrs", "ms", "mx", "dr", "prof", "rev", "hon", "other"] as const;
export type Honorific = (typeof HONORIFIC_VALUES)[number];

// ── Gender — source: shared/config/gender.config.json ─
export const GENDER_VALUES = ["male", "female", "non_binary", "prefer_not_to_say"] as const;
export type Gender = (typeof GENDER_VALUES)[number];

// ── MaritalStatus — source: shared/config/marital_status.config.json ─
export const MARITAL_STATUS_VALUES = ["single", "married", "domestic_partnership", "divorced", "widowed", "prefer_not_to_say"] as const;
export type MaritalStatus = (typeof MARITAL_STATUS_VALUES)[number];

// ── PayFrequency — source: shared/config/pay_frequency.config.json ─
export const PAY_FREQUENCY_VALUES = ["hourly", "weekly", "biweekly", "semimonthly", "monthly", "annual"] as const;
export type PayFrequency = (typeof PAY_FREQUENCY_VALUES)[number];

// ── JobChangeReason — source: shared/config/job_change_reason.config.json ─
export const JOB_CHANGE_REASON_VALUES = ["hire", "promotion", "transfer", "demotion", "lateral", "reorganization", "correction"] as const;
export type JobChangeReason = (typeof JOB_CHANGE_REASON_VALUES)[number];

// ── CompensationChangeReason — source: shared/config/compensation_change_reason.config.json ─
export const COMPENSATION_CHANGE_REASON_VALUES = ["hire", "merit", "promotion", "adjustment", "cost_of_living", "market", "correction"] as const;
export type CompensationChangeReason = (typeof COMPENSATION_CHANGE_REASON_VALUES)[number];

// ── EmployeeSkillCategory — source: shared/config/employee_skill_category.config.json ─
export const EMPLOYEE_SKILL_CATEGORY_VALUES = ["technical", "soft_skill", "language", "certification", "license"] as const;
export type EmployeeSkillCategory = (typeof EMPLOYEE_SKILL_CATEGORY_VALUES)[number];

export const employeeSkillCategoryIcon: Record<EmployeeSkillCategory, string> = {
  "technical": "Sparkles",
  "soft_skill": "MessageSquare",
  "language": "BookOpen",
  "certification": "Award",
  "license": "Shield",
};

// ── SkillProficiencyLevel — source: shared/config/skill_proficiency_level.config.json ─
export const SKILL_PROFICIENCY_LEVEL_VALUES = ["beginner", "intermediate", "advanced", "expert"] as const;
export type SkillProficiencyLevel = (typeof SKILL_PROFICIENCY_LEVEL_VALUES)[number];

// ── TimeEntrySource — source: shared/config/time_entry_source.config.json ─
export const TIME_ENTRY_SOURCE_VALUES = ["kiosk", "web", "import", "manual", "api"] as const;
export type TimeEntrySource = (typeof TIME_ENTRY_SOURCE_VALUES)[number];

// ── TimeEntryStatus — source: shared/config/time_entry_status.config.json ─
export const TIME_ENTRY_STATUS_VALUES = ["active", "completed", "needs_review", "edited"] as const;
export type TimeEntryStatus = (typeof TIME_ENTRY_STATUS_VALUES)[number];

export const timeEntryStatusTone: Record<TimeEntryStatus, string> = {
  "active": "info",
  "completed": "success",
  "needs_review": "error",
  "edited": "neutral",
};

// ── TimePremiumRuleType — source: shared/config/time_premium_rule_type.config.json ─
export const TIME_PREMIUM_RULE_TYPE_VALUES = ["daily_overtime", "weekly_overtime", "day_of_week", "time_of_day"] as const;
export type TimePremiumRuleType = (typeof TIME_PREMIUM_RULE_TYPE_VALUES)[number];

// ── LeavePolicyType — source: shared/config/leave_policy_type.config.json ─
export const LEAVE_POLICY_TYPE_VALUES = ["accrual", "unlimited"] as const;
export type LeavePolicyType = (typeof LEAVE_POLICY_TYPE_VALUES)[number];

// ── LeaveAccrualMethod — source: shared/config/leave_accrual_method.config.json ─
export const LEAVE_ACCRUAL_METHOD_VALUES = ["annual", "monthly", "biweekly"] as const;
export type LeaveAccrualMethod = (typeof LEAVE_ACCRUAL_METHOD_VALUES)[number];

// ── LeaveHalfDayPeriod — source: shared/config/leave_half_day_period.config.json ─
export const LEAVE_HALF_DAY_PERIOD_VALUES = ["morning", "afternoon"] as const;
export type LeaveHalfDayPeriod = (typeof LEAVE_HALF_DAY_PERIOD_VALUES)[number];

// ── LeaveRequestStatus — source: shared/config/leave_request_status.config.json ─
export const LEAVE_REQUEST_STATUS_VALUES = ["pending", "approved", "rejected", "cancelled"] as const;
export type LeaveRequestStatus = (typeof LEAVE_REQUEST_STATUS_VALUES)[number];

export const leaveRequestStatusTone: Record<LeaveRequestStatus, string> = {
  "pending": "warning",
  "approved": "success",
  "rejected": "error",
  "cancelled": "neutral",
};

// ── LeavePolicyAssignmentType — source: shared/config/leave_policy_assignment_type.config.json ─
export const LEAVE_POLICY_ASSIGNMENT_TYPE_VALUES = ["rule", "employee"] as const;
export type LeavePolicyAssignmentType = (typeof LEAVE_POLICY_ASSIGNMENT_TYPE_VALUES)[number];

// ── HolidayEntryType — source: shared/config/holiday_entry_type.config.json ─
export const HOLIDAY_ENTRY_TYPE_VALUES = ["holiday", "half_day", "working_day"] as const;
export type HolidayEntryType = (typeof HOLIDAY_ENTRY_TYPE_VALUES)[number];

export const holidayEntryTypeTone: Record<HolidayEntryType, string> = {
  "holiday": "info",
  "half_day": "warning",
  "working_day": "neutral",
};

// ── LeaveBlackoutEnforcement — source: shared/config/leave_blackout_enforcement.config.json ─
export const LEAVE_BLACKOUT_ENFORCEMENT_VALUES = ["hard", "soft"] as const;
export type LeaveBlackoutEnforcement = (typeof LEAVE_BLACKOUT_ENFORCEMENT_VALUES)[number];

export const leaveBlackoutEnforcementTone: Record<LeaveBlackoutEnforcement, string> = {
  "hard": "error",
  "soft": "warning",
};

// ── PeopleReviewRaterType — source: shared/config/people_review_rater_type.config.json ─
export const PEOPLE_REVIEW_RATER_TYPE_VALUES = ["self", "manager", "peer", "upward", "skip_level", "custom"] as const;
export type PeopleReviewRaterType = (typeof PEOPLE_REVIEW_RATER_TYPE_VALUES)[number];

// ── PeopleReviewQuestionType — source: shared/config/people_review_question_type.config.json ─
export const PEOPLE_REVIEW_QUESTION_TYPE_VALUES = ["text", "rating", "select", "multi_select", "competency", "goal", "table"] as const;
export type PeopleReviewQuestionType = (typeof PEOPLE_REVIEW_QUESTION_TYPE_VALUES)[number];

// ── PeopleReviewCyclePhase — source: shared/config/people_review_cycle_phase.config.json ─
export const PEOPLE_REVIEW_CYCLE_PHASE_VALUES = ["nomination", "self", "peer_upward", "manager", "calibration", "release", "acknowledgment"] as const;
export type PeopleReviewCyclePhase = (typeof PEOPLE_REVIEW_CYCLE_PHASE_VALUES)[number];

// ── PeopleReviewStatus — source: shared/config/people_review_status.config.json ─
export const PEOPLE_REVIEW_STATUS_VALUES = ["not_started", "in_progress", "submitted", "released", "acknowledged", "declined"] as const;
export type PeopleReviewStatus = (typeof PEOPLE_REVIEW_STATUS_VALUES)[number];

export const peopleReviewStatusTone: Record<PeopleReviewStatus, string> = {
  "not_started": "neutral",
  "in_progress": "info",
  "submitted": "info",
  "released": "success",
  "acknowledged": "success",
  "declined": "warning",
};

export const peopleReviewStatusTransitions: Record<PeopleReviewStatus, PeopleReviewStatus[]> = {
  "not_started": ["in_progress", "declined"],
  "in_progress": ["submitted", "declined"],
  "submitted": ["released", "in_progress"],
  "released": ["acknowledged"],
  "acknowledged": [],
  "declined": [],
};

export const peopleReviewStatusIsTerminal: Record<PeopleReviewStatus, boolean> = {
  "not_started": false,
  "in_progress": false,
  "submitted": false,
  "released": false,
  "acknowledged": true,
  "declined": true,
};

// ── PeopleReviewCycleStatus — source: shared/config/people_review_cycle_status.config.json ─
export const PEOPLE_REVIEW_CYCLE_STATUS_VALUES = ["draft", "active", "calibrating", "completed", "cancelled"] as const;
export type PeopleReviewCycleStatus = (typeof PEOPLE_REVIEW_CYCLE_STATUS_VALUES)[number];

export const peopleReviewCycleStatusTone: Record<PeopleReviewCycleStatus, string> = {
  "draft": "neutral",
  "active": "info",
  "calibrating": "warning",
  "completed": "success",
  "cancelled": "neutral",
};

export const peopleReviewCycleStatusTransitions: Record<PeopleReviewCycleStatus, PeopleReviewCycleStatus[]> = {
  "draft": ["active", "cancelled"],
  "active": ["calibrating", "completed", "cancelled"],
  "calibrating": ["completed"],
  "completed": ["active"],
  "cancelled": [],
};

export const peopleReviewCycleStatusIsTerminal: Record<PeopleReviewCycleStatus, boolean> = {
  "draft": false,
  "active": false,
  "calibrating": false,
  "completed": true,
  "cancelled": true,
};

// ── PeopleReviewNominationStatus — source: shared/config/people_review_nomination_status.config.json ─
export const PEOPLE_REVIEW_NOMINATION_STATUS_VALUES = ["suggested", "pending_approval", "approved", "rejected", "removed"] as const;
export type PeopleReviewNominationStatus = (typeof PEOPLE_REVIEW_NOMINATION_STATUS_VALUES)[number];

export const peopleReviewNominationStatusTone: Record<PeopleReviewNominationStatus, string> = {
  "suggested": "neutral",
  "pending_approval": "warning",
  "approved": "success",
  "rejected": "error",
  "removed": "neutral",
};

export const peopleReviewNominationStatusIsTerminal: Record<PeopleReviewNominationStatus, boolean> = {
  "suggested": false,
  "pending_approval": false,
  "approved": true,
  "rejected": true,
  "removed": true,
};

// ── PeopleReviewCycleType — source: shared/config/people_review_cycle_type.config.json ─
export const PEOPLE_REVIEW_CYCLE_TYPE_VALUES = ["annual", "semi_annual", "quarterly", "probation", "ad_hoc"] as const;
export type PeopleReviewCycleType = (typeof PEOPLE_REVIEW_CYCLE_TYPE_VALUES)[number];

// ── PeopleReviewParticipantStatus — source: shared/config/people_review_participant_status.config.json ─
export const PEOPLE_REVIEW_PARTICIPANT_STATUS_VALUES = ["active", "excluded", "completed"] as const;
export type PeopleReviewParticipantStatus = (typeof PEOPLE_REVIEW_PARTICIPANT_STATUS_VALUES)[number];

export const peopleReviewParticipantStatusTone: Record<PeopleReviewParticipantStatus, string> = {
  "active": "info",
  "excluded": "neutral",
  "completed": "success",
};

export const peopleReviewParticipantStatusIsTerminal: Record<PeopleReviewParticipantStatus, boolean> = {
  "active": false,
  "excluded": true,
  "completed": true,
};

// ── PeopleReviewCalibrationStatus — source: shared/config/people_review_calibration_status.config.json ─
export const PEOPLE_REVIEW_CALIBRATION_STATUS_VALUES = ["draft", "in_progress", "completed"] as const;
export type PeopleReviewCalibrationStatus = (typeof PEOPLE_REVIEW_CALIBRATION_STATUS_VALUES)[number];

export const peopleReviewCalibrationStatusTone: Record<PeopleReviewCalibrationStatus, string> = {
  "draft": "neutral",
  "in_progress": "info",
  "completed": "success",
};

export const peopleReviewCalibrationStatusIsTerminal: Record<PeopleReviewCalibrationStatus, boolean> = {
  "draft": false,
  "in_progress": false,
  "completed": true,
};

// ── PeopleRatingScaleDisplayMode — source: shared/config/people_rating_scale_display_mode.config.json ─
export const PEOPLE_RATING_SCALE_DISPLAY_MODE_VALUES = ["numbers", "labels", "both"] as const;
export type PeopleRatingScaleDisplayMode = (typeof PEOPLE_RATING_SCALE_DISPLAY_MODE_VALUES)[number];

// ── PeopleReviewOverallRatingMode — source: shared/config/people_review_overall_rating_mode.config.json ─
export const PEOPLE_REVIEW_OVERALL_RATING_MODE_VALUES = ["none", "manual", "calculated"] as const;
export type PeopleReviewOverallRatingMode = (typeof PEOPLE_REVIEW_OVERALL_RATING_MODE_VALUES)[number];

// ── PeopleReviewReleaseMode — source: shared/config/people_review_release_mode.config.json ─
export const PEOPLE_REVIEW_RELEASE_MODE_VALUES = ["on_submit", "on_share", "on_cycle_end"] as const;
export type PeopleReviewReleaseMode = (typeof PEOPLE_REVIEW_RELEASE_MODE_VALUES)[number];

// ── PeopleReviewExclusionReason — source: shared/config/people_review_exclusion_reason.config.json ─
export const PEOPLE_REVIEW_EXCLUSION_REASON_VALUES = ["no_user_account", "no_manager", "no_skip_level", "no_direct_reports", "no_peers_nominated", "insufficient_peers", "no_custom_raters", "manual"] as const;
export type PeopleReviewExclusionReason = (typeof PEOPLE_REVIEW_EXCLUSION_REASON_VALUES)[number];

// ── PeopleReviewUnresolvedReason — source: shared/config/people_review_unresolved_reason.config.json ─
export const PEOPLE_REVIEW_UNRESOLVED_REASON_VALUES = ["no_template", "nomination_required", "no_custom_source"] as const;
export type PeopleReviewUnresolvedReason = (typeof PEOPLE_REVIEW_UNRESOLVED_REASON_VALUES)[number];

// ── PeopleReviewNominationMode — source: shared/config/people_review_nomination_mode.config.json ─
export const PEOPLE_REVIEW_NOMINATION_MODE_VALUES = ["off", "manager_assigns", "employee_nominates", "employee_nominates_manager_approves"] as const;
export type PeopleReviewNominationMode = (typeof PEOPLE_REVIEW_NOMINATION_MODE_VALUES)[number];

// ── PeopleGoalStatus — source: shared/config/people_goal_status.config.json ─
export const PEOPLE_GOAL_STATUS_VALUES = ["draft", "active", "at_risk", "achieved", "missed", "cancelled"] as const;
export type PeopleGoalStatus = (typeof PEOPLE_GOAL_STATUS_VALUES)[number];

export const peopleGoalStatusTone: Record<PeopleGoalStatus, string> = {
  "draft": "neutral",
  "active": "info",
  "at_risk": "warning",
  "achieved": "success",
  "missed": "error",
  "cancelled": "neutral",
};

// ── PeopleGoalMeasureType — source: shared/config/people_goal_measure_type.config.json ─
export const PEOPLE_GOAL_MEASURE_TYPE_VALUES = ["percentage", "numeric", "currency", "complete"] as const;
export type PeopleGoalMeasureType = (typeof PEOPLE_GOAL_MEASURE_TYPE_VALUES)[number];

// ── OneOnOneStatus — source: shared/config/one_on_one_status.config.json ─
export const ONE_ON_ONE_STATUS_VALUES = ["scheduled", "completed", "cancelled"] as const;
export type OneOnOneStatus = (typeof ONE_ON_ONE_STATUS_VALUES)[number];

export const oneOnOneStatusIcon: Record<OneOnOneStatus, string> = {
  "scheduled": "CalendarClock",
  "completed": "CheckCircle2",
  "cancelled": "CalendarX",
};

export const oneOnOneStatusTone: Record<OneOnOneStatus, string> = {
  "scheduled": "info",
  "completed": "success",
  "cancelled": "neutral",
};

export const oneOnOneStatusIsTerminal: Record<OneOnOneStatus, boolean> = {
  "scheduled": false,
  "completed": true,
  "cancelled": true,
};

// ── OneOnOneRecurrence — source: shared/config/one_on_one_recurrence.config.json ─
export const ONE_ON_ONE_RECURRENCE_VALUES = ["none", "weekly", "biweekly", "monthly"] as const;
export type OneOnOneRecurrence = (typeof ONE_ON_ONE_RECURRENCE_VALUES)[number];

export const oneOnOneRecurrenceIntervalDays: Record<OneOnOneRecurrence, 0 | 7 | 14 | 28> = {
  "none": 0,
  "weekly": 7,
  "biweekly": 14,
  "monthly": 28,
};

// ── OneOnOneNoteVisibility — source: shared/config/one_on_one_note_visibility.config.json ─
export const ONE_ON_ONE_NOTE_VISIBILITY_VALUES = ["shared", "private"] as const;
export type OneOnOneNoteVisibility = (typeof ONE_ON_ONE_NOTE_VISIBILITY_VALUES)[number];

export const oneOnOneNoteVisibilityIcon: Record<OneOnOneNoteVisibility, string> = {
  "shared": "Users",
  "private": "Lock",
};

export const oneOnOneNoteVisibilityTone: Record<OneOnOneNoteVisibility, string> = {
  "shared": "info",
  "private": "neutral",
};

// ── OneOnOneActionItemStatus — source: shared/config/one_on_one_action_item_status.config.json ─
export const ONE_ON_ONE_ACTION_ITEM_STATUS_VALUES = ["open", "completed", "cancelled"] as const;
export type OneOnOneActionItemStatus = (typeof ONE_ON_ONE_ACTION_ITEM_STATUS_VALUES)[number];

export const oneOnOneActionItemStatusIcon: Record<OneOnOneActionItemStatus, string> = {
  "open": "Circle",
  "completed": "CheckCircle2",
  "cancelled": "XCircle",
};

export const oneOnOneActionItemStatusTone: Record<OneOnOneActionItemStatus, string> = {
  "open": "warning",
  "completed": "success",
  "cancelled": "neutral",
};

export const oneOnOneActionItemStatusIsTerminal: Record<OneOnOneActionItemStatus, boolean> = {
  "open": false,
  "completed": true,
  "cancelled": true,
};

// ── PeopleFeedbackVisibility — source: shared/config/people_feedback_visibility.config.json ─
export const PEOPLE_FEEDBACK_VISIBILITY_VALUES = ["private", "subject_and_manager", "manager_only", "public"] as const;
export type PeopleFeedbackVisibility = (typeof PEOPLE_FEEDBACK_VISIBILITY_VALUES)[number];

export const peopleFeedbackVisibilityTone: Record<PeopleFeedbackVisibility, string> = {
  "private": "neutral",
  "subject_and_manager": "info",
  "manager_only": "warning",
  "public": "success",
};

// ── PeopleRecognitionVisibility — source: shared/config/people_recognition_visibility.config.json ─
export const PEOPLE_RECOGNITION_VISIBILITY_VALUES = ["private", "public"] as const;
export type PeopleRecognitionVisibility = (typeof PEOPLE_RECOGNITION_VISIBILITY_VALUES)[number];

export const peopleRecognitionVisibilityTone: Record<PeopleRecognitionVisibility, string> = {
  "private": "neutral",
  "public": "success",
};

// ── PeopleFeedbackRequestStatus — source: shared/config/people_feedback_request_status.config.json ─
export const PEOPLE_FEEDBACK_REQUEST_STATUS_VALUES = ["pending", "answered", "closed"] as const;
export type PeopleFeedbackRequestStatus = (typeof PEOPLE_FEEDBACK_REQUEST_STATUS_VALUES)[number];

export const peopleFeedbackRequestStatusTone: Record<PeopleFeedbackRequestStatus, string> = {
  "pending": "warning",
  "answered": "success",
  "closed": "neutral",
};

// ── WhatsAppChannelLevel — source: shared/config/whatsapp_channel_level.config.json ─
export const WHATSAPP_CHANNEL_LEVEL_VALUES = ["capture_only", "two_way"] as const;
export type WhatsAppChannelLevel = (typeof WHATSAPP_CHANNEL_LEVEL_VALUES)[number];

// ── FrstEntryType — source: shared/config/frst_entry_type.config.json ─
export const FRST_ENTRY_TYPE_VALUES = ["disbursement_in", "disbursement_out", "profit_share"] as const;
export type FrstEntryType = (typeof FRST_ENTRY_TYPE_VALUES)[number];

export const frstEntryTypeBadgeClass: Record<FrstEntryType, string> = {
  "disbursement_in": "bg-warning/10 text-warning",
  "disbursement_out": "bg-info/10 text-info",
  "profit_share": "bg-success/10 text-success",
};

export const frstEntryTypeColor: Record<FrstEntryType, string> = {
  "disbursement_in": "#D97706",
  "disbursement_out": "#3B82F6",
  "profit_share": "#10B981",
};

// ── FrstDirection — source: shared/config/frst_direction.config.json ─
export const FRST_DIRECTION_VALUES = ["receivable", "payable"] as const;
export type FrstDirection = (typeof FRST_DIRECTION_VALUES)[number];

export const frstDirectionBadgeClass: Record<FrstDirection, string> = {
  "receivable": "bg-success/10 text-success",
  "payable": "bg-warning/10 text-warning",
};

export const frstDirectionColor: Record<FrstDirection, string> = {
  "receivable": "#10B981",
  "payable": "#D97706",
};

// ── FrstSettlementRunStatus — source: shared/config/frst_settlement_run_status.config.json ─
export const FRST_SETTLEMENT_RUN_STATUS_VALUES = ["draft", "posted", "settled", "void"] as const;
export type FrstSettlementRunStatus = (typeof FRST_SETTLEMENT_RUN_STATUS_VALUES)[number];

export const frstSettlementRunStatusBadgeClass: Record<FrstSettlementRunStatus, string> = {
  "draft": "bg-muted text-muted-foreground",
  "posted": "bg-info/10 text-info",
  "settled": "bg-success/10 text-success",
  "void": "bg-destructive/10 text-destructive",
};

export const frstSettlementRunStatusColor: Record<FrstSettlementRunStatus, string> = {
  "draft": "#64748B",
  "posted": "#3B82F6",
  "settled": "#10B981",
  "void": "#DC2626",
};

export const frstSettlementRunStatusIsTerminal: Record<FrstSettlementRunStatus, boolean> = {
  "draft": false,
  "posted": false,
  "settled": true,
  "void": true,
};

// ── FrstNettingFrequency — source: shared/config/frst_netting_frequency.config.json ─
export const FRST_NETTING_FREQUENCY_VALUES = ["monthly", "per_shipment", "manual"] as const;
export type FrstNettingFrequency = (typeof FRST_NETTING_FREQUENCY_VALUES)[number];

export const frstNettingFrequencyBadgeClass: Record<FrstNettingFrequency, string> = {
  "monthly": "bg-info/10 text-info",
  "per_shipment": "bg-module-accent/15 text-module-accent",
  "manual": "bg-muted text-muted-foreground",
};

export const frstNettingFrequencyColor: Record<FrstNettingFrequency, string> = {
  "monthly": "#3B82F6",
  "per_shipment": "#8B5CF6",
  "manual": "#64748B",
};

// ── CardBrand — source: shared/config/card_brand.config.json ─
export const CARD_BRAND_VALUES = ["visa", "mastercard", "amex", "discover", "diners", "jcb", "unionpay", "other"] as const;
export type CardBrand = (typeof CARD_BRAND_VALUES)[number];

// ── CardFunding — source: shared/config/card_funding.config.json ─
export const CARD_FUNDING_VALUES = ["credit", "debit", "prepaid", "unknown"] as const;
export type CardFunding = (typeof CARD_FUNDING_VALUES)[number];

// ── MediationThreadStatus — source: shared/config/mediation_thread_status.config.json ─
export const MEDIATION_THREAD_STATUS_VALUES = ["open", "archived"] as const;
export type MediationThreadStatus = (typeof MEDIATION_THREAD_STATUS_VALUES)[number];

export const mediationThreadStatusBadgeClass: Record<MediationThreadStatus, string> = {
  "open": "bg-success/10 text-success",
  "archived": "bg-muted text-muted-foreground",
};

export const mediationThreadStatusColor: Record<MediationThreadStatus, string> = {
  "open": "#10B981",
  "archived": "#64748B",
};

export const mediationThreadStatusIsTerminal: Record<MediationThreadStatus, boolean> = {
  "open": false,
  "archived": true,
};

// ── MediationSideRole — source: shared/config/mediation_side_role.config.json ─
export const MEDIATION_SIDE_ROLE_VALUES = ["client", "supplier"] as const;
export type MediationSideRole = (typeof MEDIATION_SIDE_ROLE_VALUES)[number];

export const mediationSideRoleBadgeClass: Record<MediationSideRole, string> = {
  "client": "bg-info/10 text-info",
  "supplier": "bg-module-accent/15 text-module-accent",
};

export const mediationSideRoleColor: Record<MediationSideRole, string> = {
  "client": "#3B82F6",
  "supplier": "#8B5CF6",
};

// ── MediationChannel — source: shared/config/mediation_channel.config.json ─
export const MEDIATION_CHANNEL_VALUES = ["portal", "email", "wecom"] as const;
export type MediationChannel = (typeof MEDIATION_CHANNEL_VALUES)[number];

export const mediationChannelBadgeClass: Record<MediationChannel, string> = {
  "portal": "bg-info/10 text-info",
  "email": "bg-muted text-muted-foreground",
  "wecom": "bg-success/10 text-success",
};

export const mediationChannelColor: Record<MediationChannel, string> = {
  "portal": "#3B82F6",
  "email": "#64748B",
  "wecom": "#22C55E",
};

// ── MediationDeliveryStatus — source: shared/config/mediation_delivery_status.config.json ─
export const MEDIATION_DELIVERY_STATUS_VALUES = ["queued", "sent", "delivered", "read", "failed", "suppressed"] as const;
export type MediationDeliveryStatus = (typeof MEDIATION_DELIVERY_STATUS_VALUES)[number];

export const mediationDeliveryStatusBadgeClass: Record<MediationDeliveryStatus, string> = {
  "queued": "bg-muted text-muted-foreground",
  "sent": "bg-info/10 text-info",
  "delivered": "bg-info/10 text-info",
  "read": "bg-success/10 text-success",
  "failed": "bg-destructive/10 text-destructive",
  "suppressed": "bg-warning/10 text-warning",
};

export const mediationDeliveryStatusColor: Record<MediationDeliveryStatus, string> = {
  "queued": "#64748B",
  "sent": "#3B82F6",
  "delivered": "#0EA5E9",
  "read": "#10B981",
  "failed": "#EF4444",
  "suppressed": "#D97706",
};

export const mediationDeliveryStatusIsTerminal: Record<MediationDeliveryStatus, boolean> = {
  "queued": false,
  "sent": false,
  "delivered": false,
  "read": true,
  "failed": true,
  "suppressed": true,
};

// ── MediationMessageVisibility — source: shared/config/mediation_message_visibility.config.json ─
export const MEDIATION_MESSAGE_VISIBILITY_VALUES = ["party", "internal"] as const;
export type MediationMessageVisibility = (typeof MEDIATION_MESSAGE_VISIBILITY_VALUES)[number];

export const mediationMessageVisibilityBadgeClass: Record<MediationMessageVisibility, string> = {
  "party": "bg-success/10 text-success",
  "internal": "bg-muted text-muted-foreground",
};

export const mediationMessageVisibilityColor: Record<MediationMessageVisibility, string> = {
  "party": "#10B981",
  "internal": "#64748B",
};

// ── MediationParticipantRole — source: shared/config/mediation_participant_role.config.json ─
export const MEDIATION_PARTICIPANT_ROLE_VALUES = ["primary", "cc"] as const;
export type MediationParticipantRole = (typeof MEDIATION_PARTICIPANT_ROLE_VALUES)[number];

export const mediationParticipantRoleBadgeClass: Record<MediationParticipantRole, string> = {
  "primary": "bg-info/10 text-info",
  "cc": "bg-muted text-muted-foreground",
};

export const mediationParticipantRoleColor: Record<MediationParticipantRole, string> = {
  "primary": "#3B82F6",
  "cc": "#64748B",
};

// ── MediationRoundType — source: shared/config/mediation_round_type.config.json ─
export const MEDIATION_ROUND_TYPE_VALUES = ["cad", "material_book", "production_media", "sample", "other"] as const;
export type MediationRoundType = (typeof MEDIATION_ROUND_TYPE_VALUES)[number];

export const mediationRoundTypeBadgeClass: Record<MediationRoundType, string> = {
  "cad": "bg-info/10 text-info",
  "material_book": "bg-muted text-muted-foreground",
  "production_media": "bg-info/10 text-info",
  "sample": "bg-success/10 text-success",
  "other": "bg-muted text-muted-foreground",
};

export const mediationRoundTypeColor: Record<MediationRoundType, string> = {
  "cad": "#3B82F6",
  "material_book": "#8B5CF6",
  "production_media": "#0EA5E9",
  "sample": "#10B981",
  "other": "#64748B",
};

export const mediationRoundTypeIcon: Record<MediationRoundType, string> = {
  "cad": "Ruler",
  "material_book": "BookOpen",
  "production_media": "Image",
  "sample": "Package",
  "other": "FileCheck",
};

// ── MediationRoundStatus — source: shared/config/mediation_round_status.config.json ─
export const MEDIATION_ROUND_STATUS_VALUES = ["draft", "awaiting_supplier", "awaiting_client", "changes_requested", "approved", "rejected", "cancelled"] as const;
export type MediationRoundStatus = (typeof MEDIATION_ROUND_STATUS_VALUES)[number];

export const mediationRoundStatusBadgeClass: Record<MediationRoundStatus, string> = {
  "draft": "bg-muted text-muted-foreground",
  "awaiting_supplier": "bg-warning/10 text-warning",
  "awaiting_client": "bg-info/10 text-info",
  "changes_requested": "bg-warning/10 text-warning border-warning/40",
  "approved": "bg-success/10 text-success",
  "rejected": "bg-destructive/10 text-destructive",
  "cancelled": "bg-muted text-muted-foreground",
};

export const mediationRoundStatusColor: Record<MediationRoundStatus, string> = {
  "draft": "#64748B",
  "awaiting_supplier": "#F59E0B",
  "awaiting_client": "#3B82F6",
  "changes_requested": "#8B5CF6",
  "approved": "#10B981",
  "rejected": "#EF4444",
  "cancelled": "#64748B",
};

export const mediationRoundStatusIsTerminal: Record<MediationRoundStatus, boolean> = {
  "draft": false,
  "awaiting_supplier": false,
  "awaiting_client": false,
  "changes_requested": false,
  "approved": true,
  "rejected": true,
  "cancelled": true,
};

// ── ShipmentDocumentIntent — source: shared/config/shipment_document_intents.config.json ─
export const SHIPMENT_DOCUMENT_INTENT_VALUES = ["commercial_invoice", "packing_list", "bl_awb", "arrival_notice", "carrier_invoice", "customs_entry_summary_7501", "certificate_of_origin", "health_certificate", "isf_filing", "fda_prior_notice"] as const;
export type ShipmentDocumentIntent = (typeof SHIPMENT_DOCUMENT_INTENT_VALUES)[number];

export const shipmentDocumentIntentI18nKey: Record<ShipmentDocumentIntent, "shipments:aiIntake.intents.commercialInvoice" | "shipments:aiIntake.intents.packingList" | "shipments:aiIntake.intents.blAwb" | "shipments:aiIntake.intents.arrivalNotice" | "shipments:aiIntake.intents.carrierInvoice" | "shipments:aiIntake.intents.customsEntrySummary7501" | "shipments:aiIntake.intents.certificateOfOrigin" | "shipments:aiIntake.intents.healthCertificate" | "shipments:aiIntake.intents.isfFiling" | "shipments:aiIntake.intents.fdaPriorNotice"> = {
  "commercial_invoice": "shipments:aiIntake.intents.commercialInvoice",
  "packing_list": "shipments:aiIntake.intents.packingList",
  "bl_awb": "shipments:aiIntake.intents.blAwb",
  "arrival_notice": "shipments:aiIntake.intents.arrivalNotice",
  "carrier_invoice": "shipments:aiIntake.intents.carrierInvoice",
  "customs_entry_summary_7501": "shipments:aiIntake.intents.customsEntrySummary7501",
  "certificate_of_origin": "shipments:aiIntake.intents.certificateOfOrigin",
  "health_certificate": "shipments:aiIntake.intents.healthCertificate",
  "isf_filing": "shipments:aiIntake.intents.isfFiling",
  "fda_prior_notice": "shipments:aiIntake.intents.fdaPriorNotice",
};

// ── SupportNotificationStatus — source: shared/config/support_notification_status.config.json ─
export const SUPPORT_NOTIFICATION_STATUS_VALUES = ["pending", "sent", "delivered", "bounced", "failed", "suppressed"] as const;
export type SupportNotificationStatus = (typeof SUPPORT_NOTIFICATION_STATUS_VALUES)[number];

export const supportNotificationStatusBadgeClass: Record<SupportNotificationStatus, string> = {
  "pending": "bg-muted text-muted-foreground",
  "sent": "bg-info/10 text-info",
  "delivered": "bg-success/10 text-success",
  "bounced": "bg-warning/10 text-warning",
  "failed": "bg-destructive/10 text-destructive",
  "suppressed": "bg-warning/10 text-warning",
};

export const supportNotificationStatusColor: Record<SupportNotificationStatus, string> = {
  "pending": "#64748B",
  "sent": "#3B82F6",
  "delivered": "#10B981",
  "bounced": "#F97316",
  "failed": "#EF4444",
  "suppressed": "#D97706",
};

// ── OutboundEmailStatus — source: shared/config/outbound_email_status.config.json ─
export const OUTBOUND_EMAIL_STATUS_VALUES = ["sent", "failed", "suppressed"] as const;
export type OutboundEmailStatus = (typeof OUTBOUND_EMAIL_STATUS_VALUES)[number];

export const outboundEmailStatusBadgeClass: Record<OutboundEmailStatus, string> = {
  "sent": "bg-success/10 text-success",
  "failed": "bg-destructive/10 text-destructive",
  "suppressed": "bg-warning/10 text-warning",
};

export const outboundEmailStatusColor: Record<OutboundEmailStatus, string> = {
  "sent": "#10B981",
  "failed": "#EF4444",
  "suppressed": "#D97706",
};

// ── NotificationEmailQueueStatus — source: shared/config/notification_email_queue_status.config.json ─
export const NOTIFICATION_EMAIL_QUEUE_STATUS_VALUES = ["pending", "processing", "sent", "failed", "skipped", "suppressed"] as const;
export type NotificationEmailQueueStatus = (typeof NOTIFICATION_EMAIL_QUEUE_STATUS_VALUES)[number];

export const notificationEmailQueueStatusBadgeClass: Record<NotificationEmailQueueStatus, string> = {
  "pending": "bg-muted text-muted-foreground",
  "processing": "bg-info/10 text-info",
  "sent": "bg-success/10 text-success",
  "failed": "bg-destructive/10 text-destructive",
  "skipped": "bg-muted text-muted-foreground",
  "suppressed": "bg-warning/10 text-warning",
};

export const notificationEmailQueueStatusColor: Record<NotificationEmailQueueStatus, string> = {
  "pending": "#64748B",
  "processing": "#3B82F6",
  "sent": "#10B981",
  "failed": "#EF4444",
  "skipped": "#94A3B8",
  "suppressed": "#D97706",
};

// ── NewsletterIssueStatus — source: shared/config/newsletter_issue_status.config.json ─
export const NEWSLETTER_ISSUE_STATUS_VALUES = ["draft", "scheduled", "sending", "sent", "failed", "canceled", "suppressed"] as const;
export type NewsletterIssueStatus = (typeof NEWSLETTER_ISSUE_STATUS_VALUES)[number];

export const newsletterIssueStatusBadgeClass: Record<NewsletterIssueStatus, string> = {
  "draft": "bg-muted text-muted-foreground",
  "scheduled": "bg-info/10 text-info",
  "sending": "bg-info/10 text-info",
  "sent": "bg-success/10 text-success",
  "failed": "bg-destructive/10 text-destructive",
  "canceled": "bg-muted text-muted-foreground",
  "suppressed": "bg-warning/10 text-warning",
};

export const newsletterIssueStatusColor: Record<NewsletterIssueStatus, string> = {
  "draft": "#64748B",
  "scheduled": "#3B82F6",
  "sending": "#0EA5E9",
  "sent": "#10B981",
  "failed": "#EF4444",
  "canceled": "#94A3B8",
  "suppressed": "#D97706",
};

// ── NewsletterDeliveryStatus — source: shared/config/newsletter_delivery_status.config.json ─
export const NEWSLETTER_DELIVERY_STATUS_VALUES = ["queued", "sent", "delivered", "opened", "clicked", "bounced", "complained", "unsubscribed", "failed", "suppressed"] as const;
export type NewsletterDeliveryStatus = (typeof NEWSLETTER_DELIVERY_STATUS_VALUES)[number];

export const newsletterDeliveryStatusBadgeClass: Record<NewsletterDeliveryStatus, string> = {
  "queued": "bg-muted text-muted-foreground",
  "sent": "bg-info/10 text-info",
  "delivered": "bg-info/10 text-info",
  "opened": "bg-success/10 text-success",
  "clicked": "bg-success/10 text-success",
  "bounced": "bg-warning/10 text-warning",
  "complained": "bg-warning/10 text-warning",
  "unsubscribed": "bg-muted text-muted-foreground",
  "failed": "bg-destructive/10 text-destructive",
  "suppressed": "bg-warning/10 text-warning",
};

export const newsletterDeliveryStatusColor: Record<NewsletterDeliveryStatus, string> = {
  "queued": "#64748B",
  "sent": "#3B82F6",
  "delivered": "#0EA5E9",
  "opened": "#10B981",
  "clicked": "#059669",
  "bounced": "#F97316",
  "complained": "#EA580C",
  "unsubscribed": "#94A3B8",
  "failed": "#EF4444",
  "suppressed": "#D97706",
};

// ── StatementRunDeliveryStatus — source: shared/config/statement_run_delivery_status.config.json ─
export const STATEMENT_RUN_DELIVERY_STATUS_VALUES = ["pending", "sent", "delivered", "failed", "bounced", "suppressed"] as const;
export type StatementRunDeliveryStatus = (typeof STATEMENT_RUN_DELIVERY_STATUS_VALUES)[number];

export const statementRunDeliveryStatusBadgeClass: Record<StatementRunDeliveryStatus, string> = {
  "pending": "bg-muted text-muted-foreground",
  "sent": "bg-info/10 text-info",
  "delivered": "bg-success/10 text-success",
  "failed": "bg-destructive/10 text-destructive",
  "bounced": "bg-warning/10 text-warning",
  "suppressed": "bg-warning/10 text-warning",
};

export const statementRunDeliveryStatusColor: Record<StatementRunDeliveryStatus, string> = {
  "pending": "#64748B",
  "sent": "#3B82F6",
  "delivered": "#10B981",
  "failed": "#EF4444",
  "bounced": "#F97316",
  "suppressed": "#D97706",
};

// ── BrokerageDistributionStatus — source: shared/config/brokerage_distribution_status.config.json ─
export const BROKERAGE_DISTRIBUTION_STATUS_VALUES = ["draft", "sent", "partially_delivered", "failed", "suppressed"] as const;
export type BrokerageDistributionStatus = (typeof BROKERAGE_DISTRIBUTION_STATUS_VALUES)[number];

export const brokerageDistributionStatusBadgeClass: Record<BrokerageDistributionStatus, string> = {
  "draft": "bg-muted text-muted-foreground",
  "sent": "bg-success/10 text-success",
  "partially_delivered": "bg-warning/10 text-warning",
  "failed": "bg-destructive/10 text-destructive",
  "suppressed": "bg-warning/10 text-warning",
};

export const brokerageDistributionStatusColor: Record<BrokerageDistributionStatus, string> = {
  "draft": "#64748B",
  "sent": "#10B981",
  "partially_delivered": "#F97316",
  "failed": "#EF4444",
  "suppressed": "#D97706",
};

// ── BrokerageDistributionRecipientStatus — source: shared/config/brokerage_distribution_recipient_status.config.json ─
export const BROKERAGE_DISTRIBUTION_RECIPIENT_STATUS_VALUES = ["pending", "sent", "bounced", "failed", "suppressed"] as const;
export type BrokerageDistributionRecipientStatus = (typeof BROKERAGE_DISTRIBUTION_RECIPIENT_STATUS_VALUES)[number];

export const brokerageDistributionRecipientStatusBadgeClass: Record<BrokerageDistributionRecipientStatus, string> = {
  "pending": "bg-muted text-muted-foreground",
  "sent": "bg-success/10 text-success",
  "bounced": "bg-warning/10 text-warning",
  "failed": "bg-destructive/10 text-destructive",
  "suppressed": "bg-warning/10 text-warning",
};

export const brokerageDistributionRecipientStatusColor: Record<BrokerageDistributionRecipientStatus, string> = {
  "pending": "#64748B",
  "sent": "#10B981",
  "bounced": "#F97316",
  "failed": "#EF4444",
  "suppressed": "#D97706",
};

// ── DocumentDistributionStatus — source: shared/config/document_distribution_status.config.json ─
export const DOCUMENT_DISTRIBUTION_STATUS_VALUES = ["pending", "sent", "failed", "suppressed"] as const;
export type DocumentDistributionStatus = (typeof DOCUMENT_DISTRIBUTION_STATUS_VALUES)[number];

export const documentDistributionStatusBadgeClass: Record<DocumentDistributionStatus, string> = {
  "pending": "bg-muted text-muted-foreground",
  "sent": "bg-success/10 text-success",
  "failed": "bg-destructive/10 text-destructive",
  "suppressed": "bg-warning/10 text-warning",
};

export const documentDistributionStatusColor: Record<DocumentDistributionStatus, string> = {
  "pending": "#64748B",
  "sent": "#10B981",
  "failed": "#EF4444",
  "suppressed": "#D97706",
};

// ── AccountantReportRunStatus — source: shared/config/accountant_report_run_status.config.json ─
export const ACCOUNTANT_REPORT_RUN_STATUS_VALUES = ["success", "skipped", "failed", "suppressed"] as const;
export type AccountantReportRunStatus = (typeof ACCOUNTANT_REPORT_RUN_STATUS_VALUES)[number];

export const accountantReportRunStatusBadgeClass: Record<AccountantReportRunStatus, string> = {
  "success": "bg-success/10 text-success",
  "skipped": "bg-muted text-muted-foreground",
  "failed": "bg-destructive/10 text-destructive",
  "suppressed": "bg-warning/10 text-warning",
};

export const accountantReportRunStatusColor: Record<AccountantReportRunStatus, string> = {
  "success": "#10B981",
  "skipped": "#94A3B8",
  "failed": "#EF4444",
  "suppressed": "#D97706",
};

// ── SysadminAlertSeverity — source: shared/config/sysadmin_alert_severities.config.json ─
export const SYSADMIN_ALERT_SEVERITY_VALUES = ["info", "warning", "error", "critical"] as const;
export type SysadminAlertSeverity = (typeof SYSADMIN_ALERT_SEVERITY_VALUES)[number];

export const sysadminAlertSeverityTone: Record<SysadminAlertSeverity, string> = {
  "info": "info",
  "warning": "warning",
  "error": "error",
  "critical": "error",
};

// ── SystemEmailStatus — source: shared/config/system_email_status.config.json ─
export const SYSTEM_EMAIL_STATUS_VALUES = ["pending", "sent", "failed", "suppressed"] as const;
export type SystemEmailStatus = (typeof SYSTEM_EMAIL_STATUS_VALUES)[number];

export const systemEmailStatusBadgeClass: Record<SystemEmailStatus, string> = {
  "pending": "bg-muted text-muted-foreground",
  "sent": "bg-success/10 text-success",
  "failed": "bg-destructive/10 text-destructive",
  "suppressed": "bg-warning/10 text-warning",
};

export const systemEmailStatusColor: Record<SystemEmailStatus, string> = {
  "pending": "#64748B",
  "sent": "#10B981",
  "failed": "#EF4444",
  "suppressed": "#D97706",
};

// ── RfqResponseState — source: shared/config/procurement.config.json § rfq_response_states ─
export const RFQ_RESPONSE_STATE_VALUES = ["invited", "sent", "responded", "declined", "no_response", "suppressed"] as const;
export type RfqResponseState = (typeof RFQ_RESPONSE_STATE_VALUES)[number];

